export const EN = {
  adName: "Image",
  averageCalls: "Average calls",
  funnelFilters: {
    multiPCHeading: "Locations to be included",
    multiPCCaption: "Target multiple Postal Codes",
    multiPCPlaceHolder: "Enter Postal Codes seperated by row",
    clearAll: "Clear All",
    addLocations: "Add Locations",
    germany: "Germany",
    switzerland: "Switzerland",
    austria: "Austria",
    selectedCodesHeading: "Selected Postal Codes",
    saveBtn: "Save Funnel Filters"
  },
  leadpannel: {
    leadCountTitle: "Lead service key figures",
    leadRateTitle: "Lead Rate",
    syncedLeads: "Synced Leads",
    unsyncedLeads: "Unsynced Leads",
    totalLeads: "Total Leads",
    appointmentChartTitle: "Appointment Tracking",
    openAppointments: "Open Lead Appointments",
    handledLeads: "Called leads",
    callsMade: "Total Calls Made",
    confirm: "Appointments Confirmed",
    cancel: "Appointments Cancelled",
    postpone: "Appointments Postponed",
    notReached: "Not Reached",
    notHandled: "Not Handled for Confirmation"
  },
  invoice: {
    heading: "Invoices",
    invoiceNumber: "Invoice Number",
    invoiceDate: "Invoice Date",
    invoiceAmount: "Amount",
    status: "Status",
    download: "Download",
    downloading: "Downloading...",
    preview: "Preview",
    opening: "Opening...",
    sendToCust: "Send to Customer",
    sending: "Sending...",
    noInvoices: "No Invoices Found",
    noInvoicesForYear: "No invoices found for this year",
    paid: "Paid",
    issued: "Issued"
  },
  toastMessage: {
    templateAppliedSuccess: "Template Applied",
    disable2FAError: "Error in disabling 2FA!",
    verificationError: "Error in verification!",
    qrCodeError: "Error in generating QR Code!",
    errorInGetting: "Error in getting {{what}}",
    errorInUpdating: "Error in updating {{what}}",
    updateFBToken: "Error in updating FB token!",
    selectAssetError: "Error in selecting asset!",
    funnelByDomain: "Error loading funnel through domain and subdomain!",
    updateLeadError: "Error in Updating Lead Data!",
    update: "Error in Updating!",
    duplicateFunnelError: "Error in duplicating funnel!",
    duplicateFunnelSuccess: "Funnel duplicated successfully!",
    duplicateFunnelWarning:
      "Unable to duplicate this funnel because it has incomplete information!",
    noTenantIdWarning:
      "There is no tenant id, you need to add contact cloud id in this funnel's customer!",
    createAssetError: "Error in creating asset!",
    createUserError: "Error in Creating User!",
    // assignUserTokenError: "Error assigning user token!",
    fetchUsersError: "Error in fetching Users!",
    updateUserError: "Error in Updating User!",
    downloadError: "Error in downloading image!",
    uploadItemError: "Error in uploading item!",
    importFunnel: "Error in importing funnel!",
    createTemplateError: "Error in creating template!",
    archiveError: "Error in archive!",
    unarchiveError: "Error in unarchive!",
    assetsUploadError: "Error in uploading assets",
    fbPagesError: "Error in fetch fb pages!",
    draftFunnel: "Error in creating draft funnel!",
    draftTemplate: "Error in creating draft template!",
    deleteTemplate: "Error in deleting template!",
    fbFormError: "Error retrieving Facebook Page forms!",
    wentWrong: "Something went wrong!",
    categoryByName: "Category by Name!",
    categoryByID: "Category by id!",
    saveCategory: "Error in saving category!",
    changePassword: "Error in Changing Password!",
    fetchInsightsError: "Error in Fetching insights!",
    saveCustomer: "Error is saving customer!",
    createCity: "Error in creating new city!",
    updateFunnels: "Error in updating funnel!",
    updateTemplate: "Error in updating template!",
    updateFunnelFilters: "Error in updating funnel filters",
    removeDomain: "Error in removing domain & sub-domain",
    fetchVersion: "Error in fetching version!",
    changeVersion: "Error in changing version!",
    downloadSuccessfully: "Download Successfully!",
    csvDownloadError: "Error in downloading csv!"
  },
  fbTokenInfoMessage: "Currenly using <strong>{{what}}</strong> facebook token",
  availableAfter: "After how many hours will the requests be available again?",
  offerFollowupMaxNotReachedAttempts:
    "Offer follow-up: maximum not reached attempts",
  callingDownTimeLabel:
    "After how many minutes without a call should a warning be sent?",
  createdLeads: "Number of Leads created",
  numberOfVisits: "Number of Visits",
  outcome: {
    jumpDirect: "Jump directly to this outcome",
    jumpEnd: "Only jump to this outcome at the end",
    restart: "Restart Questionaire"
  },
  settings: {
    welcome: "Welcome to profile settings:",
    connectFB: "Connect with Facebook"
  },
  // siteSettings: {
  //   token: "Token"
  // },
  funnelIntegration: {
    autopilot: {
      title: "Autopilot",
      active: "Active (switched on in the Autopilot)",
      inactive: "Not active",
      readOnly: "The Autopilot switches itself on and off.",
      ccHint:
        "Autopilot active: requests go to Contact Cloud only with a booked appointment.",
      leadStatus: {
        WITH_AUTOPILOT: "With the Autopilot (WhatsApp)",
        IN_LEADSERVICE: "In the Lead Service",
        RELEASED: "Appointment released to Contact Cloud on {{date}}",
        CLOSED: "Ended without appointment",
        ENDED: "Autopilot switched off, normal lead"
      }
    },
    tabTitleActiveTooltip: "Has active integrations",
    tabTitleNotIntegratedTooltip: "Not Integrated",
    error: "Error in integration!",
    updateIntegration: "Error in updating integration!",
    removeIntegration: "Error in removing integration!",
    descriptionPlaceholder: "Add integration description here",
    deleteIntegrationWarning: `Do you want to <strong>delete</strong> this integration?`,
    deleteAppointmentLinkWarning: `Do you want to <strong>delete</strong> appointment link?`,
    deleteAccountLinkWarning: `Do you want to <strong>delete</strong> account link?`,
    webhookPlaceholder:
      "Enter webhook URL (you get this information from Zapier)",
    updateToastMsg: "Integration updated successfully!",
    enableDialogMsg: "Do you want to <strong>enable</strong> this integration?",
    disableDialogMsg:
      "Do you want to <strong>disable</strong> this integration?",
    sendDataHeading: "Send Data",
    selectOptions: {
      never: "Never",
      immediately: "Send Immediately",
      afterConfirmation: "Send after confirmation",
      leadServiceInfo: "Enable Lead Service 2.0 first!"
    },
    leadService: {
      enableDialogMsg:
        "Do you want to <strong>enable</strong> lead service 2.0?",
      disableDialogMsg:
        "Do you want to <strong>disable</strong> lead service 2.0?",
      warningDialogMessage: `By disabling lead service 2.0, your settings for send <strong>email</strong> to customer, <strong>contact cloud</strong> or <strong>zapier</strong> integration will be compromised!<div>Do you want to continue?</div>`,
      enablePlusMsg: "Do you want to <strong>enable</strong> lead service+?",
      disablePlusMsg: "Do you want to <strong>disable</strong> lead service+?",
      leadServiceCompanyNameLabel: "Leadservice Company Name",
      leadServiceProductNameLabel: "Product Name",
      individualNoteLabel: "Individual Note"
    },
    leadServicePlus: {
      priceTypeLabel: "Price Type",
      calculationLabel: "Calculation",
      fixedPriceLabel: "Fixed Price",
      areaQueryLabel: "Area Query",
      pricePerInvoiceUnitLabel: "Price per invoice unit",
      fixedPricePerInvoiceUnitLabel: "Fixed price per invoice unit",
      nameOfAccountingUnitLabel: "Name of accounting unit",
      specifyHerePlaceholder: "Specify here",
      budgetQueryLimitsLabel: "Budget query limits",
      pricePerAreaLabel: "Price per area",
      disabledBudgetLimitRadioMsg: "Add Name of accounting unit to enable",
      removeUnitNameConfirmationMsg: `If you remove the <strong>Name of accounting unit</strong>, your <strong>Price Type</strong> for <strong>Area Query</strong> will be affected!<div>Do you want to continue?</div>`,
      optionalQuestion: "Optional Soft Questions",
      question: "Question",
      budgetAreaOfQueryBounds: "Budget area of query",
      addAnotherOption: "Add another option",
      variantNamePlaceholder: "Option name",
      variantSelectLabel: "Requested option",
      variantSelectPlaceholder: "Select option",
      variantNameRequired:
        "All options need a name once multiple options exist.",
      uniqueVariantNameRequired: "Each option name must be unique.",
      invalidVariantPrice: "Each option needs a valid price."
    },
    alternativeAddress: {
      checkboxLabel: "Alternative Address",
      error: "Failed to update alternative address"
    },
    email: {
      alertDialogMessage: `Sorry, you need to enable <strong>lead service 2.0</strong> first!`,
      label: "Send Email To Customer",
      toastError: "Error in updating customer email configuration!"
    },
    slack: {
      checkboxLabel: "Slack Notifications",
      fieldLabel: "Notification-URL",
      fieldPlaceholder:
        "Enter the notification URL (you get this information from Slack).",
      toastError: "Error in slack integration"
    },
    reclaimMode: {
      heading: "Filtered Lead Mode",
      checkboxLabel: "Enable Filtered Lead Mode"
    },
    contactCloud: {
      connectBtn: "Connect",
      contactCloudSetup: "Contact Cloud Setup",
      optionsError: {
        users: "user options",
        products: "product options",
        jobs: "job options"
      }
    },
    leadpool: {
      heading: "Leadpool"
    },
    appointment: {
      heading: "Customer Appointment",
      label: "Appointment Link",
      placeholder: "Add Calendly Link",
      confirm: "Appointment Confirmation",
      type: "Appointment Type",
      onsite: "Onsite",
      phone: "Phone",
      yes: "Yes",
      no: "No",
      recipients: "Appointment confirmation recipients",
      recipient: "Appointment confirmation recipient {{number}}",
      optional: "(optional)",
      recipientPlaceholder: "name@company.com",
      recipientsHint:
        'Receive the appointment confirmation, cancellation, postponement and the "lead not reached" email. The new-lead notification is set separately in the "Email" section.',
      recipientsFallback:
        'Not set yet: goes to all addresses in the "Email" section'
    },
    advertisingAccount: {
      heading: "Advertising Account",
      label: "Account Link",
      placeholder: "Enter account link"
    }
  },
  modalContent: {
    saveAsTemplate: "Save as{{new}}template",
    deleteOutcome: `Are you sure you want to <span class="text-danger">delete</span> this outcome? 
    <div>Because it is a response action in <span class="text-danger fw-bold">funnel QA</span><div>`,
    deleteFunnel: `Are you sure you want to <span class="text-danger">delete</span> this question?`,
    responseAction: "Because it's a response action in",
    funnel: {
      unsavedWarning:
        "You have unsaved changes. Save this to save as a template",
      unarchiveFunnelTitle: "Remove funnel from archive",
      unarchiveFunnelMsg: `Do you want to <span class="fw-bold"> remove </span> this <span class="fw-bold"> funnel from the archive? </span>`,
      note: "This funnel does not have a domain and subdomain!",
      discardUnsavedWarning: `Your unsaved funnel will be <strong>discarded</strong>. Do you want to continue?`
    }
  },
  adCopy: {
    title: "Ad Copy",
    noAdMessage: "No Ad Extracted",
    dataCompleted: "Training Data Completed!",
    emojis: "Emojis",
    funnelURL: "Funnel-URL"
  },
  adDuplicator: {
    fetchAdAcc: "Fetch ad accounts",
    fetchAd: "Fetch Ad",
    pasteAndFetchAd: "Paste and Fetch Ad",
    uploadAdsToFb: "Upload Ads to Facebook",
    clearAllAds: "Clear All",
    title: "Ad Duplicator",
    viewIdLabel: "Ad-ID",
    imgStatus: "Image status",
    adStatus: "Ad status",
    disabledDropImageMsg: "Verify Ad To Upload",
    adUploadingStatus: {
      waiting: {
        status: "READY TO CREATE",
        message: "I'm waiting to create a Facebook ad.."
      },
      uploading: {
        status: "UPLOADING...",
        message: "Creating ad to facebook."
      },
      success: { status: "SUCCESS", message: "Ad created Successfully." },
      rejected: { status: "REJECTED" }
    }
  },
  basics: "Basics",
  leadSyncMsg:
    "Lead is already synced. Do you want to <strong>sync</strong> again?",
  passwordChangeMsg: "Password successfully changed!",
  overview: "Overview",
  infoDetails: "Info-Details",
  hubspotID: "Hubspot ID",
  hubspotProjectID: "Hubspot Project ID",
  contactCloudID: "Contact Cloud ID",
  createNewFunnel: "Create New Funnel",
  updateTemplate: "Update Template",
  createTemplate: "Create New Template",
  createFunnelFromTemplate: "Create a new funnel from this template",
  dropImageMsg: "DROP OR UPLOAD AN IMAGE HERE",
  dropPdfMsg: "DROP OR UPLOAD PDF HERE",
  noIntegrationMsg: "No integration found!",
  noAssetMsg: "No Asset Found",
  noResults: "No Results",
  overlayMsg: "Is Loading",
  duplicateLoaderMessage: "Duplicate funnel...",
  leadServiceError: "Failed to update funnel lead service!",
  clipBoardNotAllowedMessage: "Please Allow clipboard permissions",
  delete: "Delete",
  notificationURLPlaceholder:
    "Enter the notification URL (you get this information from Zapier).",
  or: "or",
  title: "Title",
  addDomainModal: {
    title: "Domain und Subdomain hinzufügen",
    btnText: "Speichern & aus dem Archiv entfernen"
  },
  viewGalleryModal: {
    title: "Choose Picture",
    searchImage: "Search Image",
    addImage: "Add New Image"
  },
  download: "Download",
  createNewCity: "Create New City",
  createNewCustomer: "Create New Customer",
  moveToCustomers: "Move to Customers",
  moveToCustomerDialog: {
    title: "Move to Customers",
    para: "Do you want to move this to customers?",
    saving: "Saving...",
    btn: "Yes"
  },
  customerStats: {
    leads: "Leads",
    budget: "Budget",
    conversionRate: "Conversion rate"
  },
  createNewCategory: "Create New Ccategory",
  createFunnelModal: {
    title: "What type of {{type}} do you want to create?",
    actions: {
      lead: "Lead",
      employee: "Employee"
    }
  },
  createIntegrationTitle: "Create integration for this funnel",
  duplicateFunnelTitle: "Confirm duplication",
  duplicateFunnelMessage:
    "Do you want to <strong>duplicate</strong> this funnel?",
  duplicateFunnelMessageForFB:
    "Do you want to <strong>duplicate this funnel without facebook form</strong> details ?",
  archiveLeadMessage: `Do you really want to <strong class = "text-lowercase" >{{archive}}</strong> the lead?`,
  archiveFunnelMessage:
    "Do you want to <strong>archive</strong> this funnel? The funnel's public page will no longer be reachable.",
  deleteTemplateMessage: `Are you sure you want to <strong class="text-danger">delete</strong> this template?`,
  deleteImageMessage: `Are you sure you want to <strong class="text-danger">delete</strong> this image?`,
  deleteCategoryMessage: `Are you sure you want to <strong class="text-danger">delete</strong> this category?`,
  deleteKeywordMessage: `Are you sure you want to <strong class="text-danger">delete</strong> this keyword?`,
  // deleteUserTokenMessage: `Are you sure you want to <strong class="text-danger" >delete</strong>  this user token?`,
  deleteCategorySuccess: "Category deleted successfully.",
  deleteKeywordSuccess: "Keyword deleted successfully.",
  // deleteUserTokenSuccess: "User token deleted successfully.",
  clearAdDuplicatorFilesTitle: "Proceed with New Ad ID",
  clearAdDuplicatorFiles:
    "You have some pending ads with old Ad ID, Do you discard pending ads and proceed with new Ad ID?",
  modern: {
    selectFunnelDesign: "Select Funnel Design",
    backgroundColorAbove: "Background Color Above",
    backgroundColorBelow: "Background Color Below",
    headerLabelColor: "Telephone and email button",
    contrastColor: "Background color of the questions",
    taglineColor: "Right column top font color",
    taglineBackground: "Right column top background color",
    callLabel: "Displayed number",
    telephoneNumber: "Which phone number should you call?",
    emailAddress: "Email Address",
    headline: "At the top of the funnel heading",
    taglineOne: "Right column top heading",
    taglineTwo: "Right column top subtitle",
    formHeading: "Heading above name & email",
    infoLabelOne: "Left column headline entry form",
    infoLabelTwo: "Left column subtitle entry form",
    infoLabelThree: "Left column note about the entry form",
    uspLabel: "USP (Advantages / Benefits)",
    addNewUspLabel: "Add USP",
    colorLabel: "Color",
    iconLabel: "Icon",
    label: "Label",
    callToActionButtonHeading: "Call to action button",
    uspLabelPlaceholder: "USP-Label hinzufügen",
    deleteUspMessage: `Are you sure you want to <strong class="text-danger">delete</strong> this USP?`,
    deleteUspSuccess: "USP deleted successfully.",
    nextButton: {
      heading: "Next Button",
      btnTextColor: "Text Color",
      btnBackgroundColor: "Background Color",
      btnHoverBackground: "Hover Background"
    }
  },
  createFunnel: "Create Funnel",
  createUser: "Create User",
  // assignUserToken: "Assign User Token",
  duplicateAnswer: "Duplicate Answer",
  deleteAnswer: "Delete Answer",
  duplicateQuestion: "Duplicate Question",
  copyQuestion: "Copy Question",
  duplicatedQuestion: "Duplicated Question",
  pasteQuestion: "Paste Question",
  pasteQuestionSuccess: "Question pasted successfully",
  pasteQuestionError: "Question Id not recognized",
  clipboardCopySuccess: "{{what}} is copied to clipboard",
  deleteQuestion: "Delete Question",
  question_one: "Question",
  question_other: "Questions",
  endQuestionnaire: "End questionnaire",
  jumpToNextQuestion: "Jump to next question",
  jumptToQuestion: "Jump to question",
  jumptToOutcome: "Jump to outcome # {{num}}",
  addNewQuestion: "Add New Question",
  addNewOutcome: "Add New Outcome",
  addIcon: "Add Icon",
  changeIcon: "Change Icon",
  layout: "Layout",
  searchImage: "Search",
  backgroundImage: "Background Image",
  companyLogo: "Company Logo",
  companyLogoBG: "Company Logo Background",
  baseColor: "Base Color",
  footerTxtColor: "Footer Text Color",
  footerColors: {
    black: "Black",
    white: "White",
    whiteShadow: "White (Shadow)"
  },
  companyLogoScale: "Company Logo Scale",
  partnerLogoSection: {
    autoLight: "Automatic – light",
    autoDark: "Automatic – black",
    manual: "Own image",
    scale: "Logo size in partner badge (%)",
    missingCompanyLogo: "Please add a company logo first"
  },
  textElements: "Text Elements",
  nextButtonText: `"Next" Button Text`,
  nextButtonBG: `"Next" Button Background`,
  waitingScreen: "Waiting Screen",
  zipCodeScreen: "Zip Code Screen",
  formScreen: "Form Screen",
  fieldTitle: "Field Title",
  fieldPlaceholder: "Field Placeholder",
  firstAndLastName: "First & Last Name",
  forQuestions: "for any questions",
  submitButton: "Submit Button",
  getAnOffer: "Get an offer now",
  freeOfCharge: "free of charge & without obligation",
  numberCheck: "Number Check",
  phoneNumberVerification: "Phone number verification",
  thankyouPage: "Thankyou Page",
  textOnThankyouPage: "Text on",
  websiteBtnForThankyouPage: "Button for website on thankyou page",
  greetingPhrase: "Greeting Phrase",
  redirect: {
    switchLabel: "Redirect Lead",
    fieldLabel: "Redirect URL",
    fieldPlaceholder: "Enter redirect URL"
  },
  emailEdit: {
    email: "Appointment Email",
    confirm: "Appointment Confirm Email",
    cancel: "Appointment Cancel Email",
    postpone: "Appointment Postpone Email",
    notReached: "Lead Not Reached Email",
    noContent: "No Content",
    subjectPlaceholder: "Email Subject",
    noSubject: "No Subject",
    subject: "Subject",
    placeholder: "Insert Placeholder",
    leadName: "Lead Name",
    leadEmail: "Lead Email",
    appointmentDate: "Appointment Date",
    appointmentTime: "Appointment Time"
  },
  cancelEditing: "Cancel Editing",
  link: "Link",
  addNewCondition: "Add New Condition",
  addNewGroup: "Add New Group",
  enterHeading: "Enter Heading",
  msgPlaceholder:
    "Write a message that will be displayed if the user does not match the above criteria.",
  customerName: "Customer Name",
  customerInfo: "Customer Information",
  summary: "Summary",
  budget90DaysLabel: "Budget of the last 90 Days",
  viewMore: "View More",
  view: "View",
  viewHere: "View here",
  categoryDescription: "Category description",
  leadPriceBenchmark: "Lead price Benchmark",
  leadQualifiedPriceBenchmark: "Qualified Lead price Benchmark",
  leadPriceCurrentText: "Facebook lead price (14 days)",
  leadQualifiedPriceCurrentText: "Qualified lead price (14 days)",
  enterCategoryDesc: "Enter category description",
  categoryForm: "Category Form",
  missingToken: "Token is missing!",
  domainArchivedMsg1:
    "This domain and subdomain is already used in an archived funnel!",
  domainArchivedMsg2: "This domain and subdomain is already in use!",
  domainAlreadyTakenMsg: `This <span class="fw-bold">domain and subdomain</span> is already taken, would you like to continue?`,
  useAnyway: "Use anyway",
  notAllowedDomainMsg: "You can't use this domain and subdomain",
  endDateWarning: "End date should be greater than start date...",
  minmaxRangeWarning: "Min value should be smaller than Max value...",
  wrongDate: "Wrong date...",
  backToLogin: "Back to Login",
  loginSuccessFull: "You have successfully logged in!",
  resetPassword: "Reset Password",
  generatePassword: "Generate Password",
  password: "Password",
  newPassword: "New Password",
  confirmNewPassword: "Confirm New Password",
  reset: "Reset",
  assetUpdateMsg: "Asset updated successfully!",
  uploadedOn: "Uploaded On",
  uploadImage: "Upload Image",
  fileType: "File Type",
  job: "Job",
  tonality: "Tonality",
  speech: "Speech",
  specialInstructions: "Special Instructions",
  open: "Open",
  views: "Views",
  contact: "Contact",
  completionRate: "Completion Rate",
  conversionRate: "Conversion Rate",
  noData: "No data to show",
  customerForm: "Customer Form",
  customerNumber: "Customer Number",
  enableAIInterviewAndDossier: "Enable AI Interview and Dossier",
  contactDetails: "Contact Details",
  selectFbPage: "Select Facebook Page",
  selectUserAccount: "Select User Account",
  selectFbForm: "Select Facebook Form",
  facebookForm: "Facebook Form",
  formQuestions: "Form questions",
  userDetails: "User Details",
  pageDetails: "Page Details",
  formDetails: "Form Details",
  getPages: "Get Pages",
  retrievePagesNote:
    "No options available! Please fetch pages first to enable options.",
  tonalities: {
    Seriös: {
      title: "Serious",
      description:
        "Used for financial services, law firms, medical products and services. The focus is on trust and professionalism"
    },
    Lässig: {
      title: "Casual",
      description:
        "Suitable for lifestyle products, casual wear, or apps for young adults. It conveys a sense of relaxation and simplicity."
    },
    Humorvoll: {
      title: "Humorous",
      description:
        "A humorous tone can be used to capture the target audience's attention, such as for snack products, games, or advertising for movies."
    },
    Inspirierend: {
      title: "Inspiring",
      description:
        "Often used for sportswear, travel advertising, or non-profit organizations. It aims to motivate the viewer and convey a sense of admiration or aspiration."
    },
    Romantisch: {
      title: "Romantic",
      description:
        "Suitable for products like perfume, jewelry, or trips to romantic destinations. It generates feelings of intimacy and passion."
    },
    Sachlich: {
      title: "Factual",
      description:
        "This tone is direct and straightforward. It could be suitable for technical products, craft services, or educational offers."
    },
    Nostalgisch: {
      title: "Nostalgic",
      description:
        "This can be used to create a feeling of longing or memory, perhaps for retro products or brands with a long history."
    },
    Provokativ: {
      title: "Provocative",
      description:
        "Some brands choose a challenging or controversial tone to attract attention and provoke discussions"
    },
    Luxuriös: {
      title: "Luxurious",
      description:
        "For high-end products like designer clothing, luxury cars, or first-class travel services. The advertising emphasizes exclusivity and sophistication."
    },
    Pädagogisch: {
      title: "Educational",
      description:
        "Informs the viewer and conveys knowledge. This might be suitable for books, educational software, or scientific products."
    }
  },
  notSynced: "Not synced yet!",
  customAnswerMsg:
    "This <strong>type</strong> of question does not require answers.",
  campaign: "Campaign",
  facebookPgID: "facebook page id",
  questionnaire: "Questionnaire",
  phoneServiceQuestionnaire: "Phone questions (Lead Service)",
  leadIdLabel: "Lead ID",
  googleAdsLead: {
    title: "Google Ads",
    id: "ID",
    campaign: "Campaign",
    adgroup: "Ad group",
    keyword: "Keyword",
    matchtype: "Match type",
    device: "Device",
    network: "Network",
    landingPage: "Landing page",
    gclid: "Google Click ID"
  },
  currentVersion: "Current Version",
  activatePrimaryMessage: `Are you sure you want to <span class="fw-bold">activate</span> this user token?`,
  connectFbMessage: `Are you sure you want to <span class="fw-bold">revalidate</span> with facebook?`,
  openProject: "Open Project",
  openAdvertisingAccount: "Open Advertising Account",
  openInTest: "Open in Test-Mode",
  script: "Script",
  leadService: "Lead Service",
  filteredLead: "Filtered Lead",
  appointmentConfirm: "Appointment confirmation",
  offerFollowup: "Offer Followup",
  funnelQA: {
    textOnly: "Text Only",
    freeText: "Free Text field",
    slider: "Slider",
    multi: "Multi Selected",
    single: "Single Selected",
    selectOption: "Select an option",
    questionPlaceholder: "Add Question Here"
  },
  funnelInsights: {
    leadService: {
      total: "Total Lead Service leads",
      open: "Open Leads",
      nameWrong: "Name Wrong Leads",
      numberWrong: "Number Wrong Leads",
      notReached: "Not Reached Leads",
      // notSuitable: "Not Suitable Leads",
      notSuitableDueToCallResult: "Not Suitable Due To Call Results",
      notSuitableDueToAccessibility: "Not Suitable Due To Accessibility",
      suitable: "Suitable Leads"
    },
    allLandingVisits: "All Landing Visits",
    visits: "Visits",
    websiteVisits: "Website Visits",
    phoneVisits: "Call attempt clicks",
    emailVisits: "Email button clicks",
    adEval: { totalBudget: "Total Budget Spent" },
    interview: {
      title: "AI Interview (after submission)",
      versionIndependent: "independent of funnel version",
      sinceActivation: "since activation on {{date}}",
      leadsTotal: "Leads created",
      shown: "Interview shown",
      stepShort: "Q",
      completed: "Completed",
      startRate: "Start rate",
      startRateSub: "answered at least one question",
      completionRate: "Completion rate",
      completionRateSub: "of shown interviews",
      avgAnswered: "Avg. answered questions",
      avgPlanned: "of avg. planned",
      voiceShare: "Voice input share",
      chips: "Chips",
      text: "Text",
      skippedImmediately: "Skipped immediately",
      skippedPartial: "Skipped after answers",
      abandoned: "Abandoned"
    }
  },
  appointmentNote: {
    book: "Appointment scheduled on: ",
    confirm: "Appointment confirmed - ",
    cancel: "Appointment cancelled",
    postpone: "Appointment postponed - new date:"
  },
  sync: "Sync",
  forwardedOnContactCloud: "Forwarded on Contact Cloud",
  forwardedTooltips: {
    success: "The lead has been forwarded to the customer",
    pending: "The lead is currently still in telephone service",
    failed: "The lead is either not suitable or has not been reached",
    aiLeadservice:
      "The lead is currently being pre-qualified by phone by the AI leadservice",
    inVerificationProcess: "The lead is in digital verification process",
    inInterviewWithAI: "The lead is currently being interviewed by the AI"
  },
  multifactor: {
    emailAuth: "Email Authenticator",
    appAuth: "App Authenticator",
    scan: {
      heading: "Scan"
    },
    verify: {
      heading: "Verify Code",
      msg: "For changing the setting, please verify the authentication code:"
    },
    configure: {
      heading: "Configuring Google Authenticator or Authy",
      step1:
        "Install Google Authenticator (IOS - Android) or Authy (IOS - Android).",
      step2: `In the authenticator app, select " + " icon.`,
      step3: `Select "Scan a barcode (or QR code)" and use the phone's camera to scan this barcode.`
    },
    title: "Multi-Factor Authentication (MFA)",
    subtitle: "Secure your account with TOTP two-factor authentication.",
    setup: "Setup",
    btnText: "Verify & Activate",
    disableHeading: "Disable Two-Factor Authentication (2FA)",
    method: "Authenticator Method",
    sendCode: "Send Code",
    sendCodeMsg: "Send a verification code to",
    verificationMsg: `Verification code has been sent! If you didn't receive the code, try again in <strong>{{timer}}</strong> seconds`
  },
  common: {
    select: "Select",
    selected: "Selected",
    font: "Font",
    problem: "Problem",
    ignore: "Ignore",
    creative: "Creative",
    understood: "Understood",
    benchmark: "Benchmarck",
    difference: "Difference",
    action: "Action",
    security: "Security",
    generate: "Generate",
    addNew: "Add New",
    user: "User",
    user_other: "Users",
    logic: "Logic",
    headline: "Headline",
    product: "Product",
    job: "Job",
    enter: "Enter",
    import: "Import",
    template: "Template",
    template_other: "Templates",
    message: "Message",
    heading: "Heading",
    lead: "Lead",
    lead_other: "Leads",
    funnel: "Funnel",
    funnel_other: "Funnels",
    name: "Name",
    email: "Email",
    syncStatus: "Sync Status",
    update: "Update",
    confirmDeletion: "Confirm Deletion",
    yes: "Yes",
    no: "No",
    selectColor: "Select Color",
    create: "Create",
    source: "Source",
    leadSource: "Lead Source",
    role: "Role",
    firstName: "First Name",
    lastName: "Last Name",
    city: "City",
    country: "Country",
    new: "New",
    old: "Old",
    changePassword: "Change Password",
    enterEmail: "Enter Email",
    forgotPassword: "Forgot Password",
    send: "Send",
    login: "Login",
    logout: "Logout",
    alreadyTaken: "Already taken",
    isAlreadyTaken: "is already taken",
    categories: "Category Name",
    back: "Back",
    save: "Save",
    templateName: "Template Name",
    postalCode: "Postal Code",
    blockedPostalCode: "Blocked Postal Code",
    blockedOn: "Blocked on",
    search: "Search",
    type: "Type",
    of: "of",
    results: "Results",
    result: "Result",
    archive: "Archive",
    unarchive: "Unarchive",
    customer: "Customer",
    activeCampaignsOnly: "Active campaigns only",
    displayFunnelsWithFbLeadsOnly: "Display Funnels with Fb Leads Only",
    customer_other: "Customers",
    address: "Address",
    category: "Category",
    category_other: "Categories",
    form: "Form",
    answer: "Answer",
    companyInfo: "Company Information",
    companyName: "Company Name",
    companyWebsite: "Company Website",
    website: "Website",
    websiteBtnTxt: "Website button text",
    dataProtection: "Data Protection",
    imprint: "Imprint",
    createCustom: "Create Custom",
    telephone: "Telephone",
    preview: "Preview",
    saveFunnel: "Save Funnel",
    cancel: "Cancel",
    description: "Description",
    close: "Close",
    edit: "Edit",
    created: "Created",
    appointmentOn: "Appointment on: ",
    to: "to",
    on: "on",
    postponedNote: "Appointment Postponed - New Appointment: ",
    from: "from",
    company: "Company",
    createNew: {
      title: "Create new {{name}}"
    },
    // assignNew: {
    //   title: "Assign new {{name}}"
    // },
    enable: "Enable",
    enabled: "Enabled",
    openInNewTab: "Open in new tab",
    sortBy: "Sort By",
    sortOrder: "Sort Order",
    performanceReport: "Performance Report",
    invoices: "Invoices",
    deleted: "DELETED",
    change: "Change",
    confirm: "Confirm!",
    appointmentDetail: "Appointment Date and Time",
    charactersCount: "Characters Count",
    inactive: "In-active",
    blockedCount: "Blocked Zip Count",
    reportType: "Report Type",
    requestTime: "Request Time",
    errorMsg: "Error Message",
    keyword: "Keyword",
    keywords: "Keywords",
    keywordImageSizeRecommendation:
      "Images should be uploaded in 1200 × 900 pixels",
    refresh: "Refresh",
    invalidPriceValue: "Please enter a valid value."
  },
  monthsName: {
    jan: "January",
    feb: "February",
    mar: "March",
    apr: "April",
    may: "May",
    jun: "June",
    jul: "July",
    aug: "August",
    sep: "September",
    oct: "October",
    nov: "November",
    dec: "December"
  },
  missingInfo: {
    leadCount: "Lead Count",
    funnel: {
      selectCategory: "Select Category",
      selectCustomer: "Select Customer"
    },
    lead: {
      selectFunnel: "Select Funnel"
    }
  },
  advancedFilter: {
    title: "Advanced Filter",
    formType: "Form Type",
    search: "Search",
    archive: "Includes Archive",
    userStatus: "User Status",
    tags: "Tags",
    status: "Status",
    leadStatus: "Lead Status",
    funnel: "Funnel",
    priceRange: "Price Range",
    dateRange: {
      today: "Today",
      yesterday: "Yesterday",
      thisWeek: "This Week",
      lastWeek: "Last Week",
      thisMonth: "This Month",
      lastMonth: "Last Month",
      thisYear: "This Year",
      lastYear: "Last Year",
      last7D: "Last 7 days",
      last14D: "Last 14 days",
      last30D: "Last 30 days",
      last90D: "Last 90 days",
      custom: "Custom Date",
      days7: "7 Days",
      days14: "14 Days",
      days30: "30 Days",
      days90: "90 Days",
      customRangeUptoNinetyDays: "Range"
    },
    fbSort: {
      leadCount: "Lead Count",
      costPerLead: "Cost Per Lead",
      click: "Click",
      reach: "Reach",
      impressions: "Impressions",
      costPerClick: "Cost Per Click",
      spend: "Spend",
      costPerQualified: "Cost per Qualified Lead",
      qualifiedCount: "Qualified Lead Count",
      leadQualify: "Lead Qualify",
      leadCost: "Lead Cost",
      conversionRate: "Conversion Rate"
    },
    sortOrder: {
      highestFirst: "Highest first",
      lowestFirst: "Lowest first"
    },
    funnelType: "Funnel Type"
  },
  sidebar: {
    dashboard: "Dashboard",
    templates: "Templates",
    funnelTemplates: "Funnel Templates",
    globalThankYouTemplate: "Thank-you Template",
    customers: "Customers",
    categories: "Categories",
    gallery: "Gallery",
    tags: "Tags",
    users: "Users",
    settings: "Settings",
    siteSettings: "Site Settings",
    profile: "Profile",
    leadAgent: "Lead Agent",
    appointmentConfirm: " Confirm Appointment",
    advertisements: "Advertisements",
    adOptimization: "Optimizations",
    blockPostalCode: "Blocked Postal Codes",
    websiteLogs: "Website Logs",
    splitTests: "Split tests",
    fulfillmentKpis: "Fulfillment KPIs"
  },
  funnelTable: {
    all: "All",
    leadCount: "Lead Count",
    lastChange: "Last Change",
    integrationStatus: "Integration Status"
  },
  templateTable: {
    lastModified: "Last Modified"
  },
  userSearchPlaceholder: "Search by name or email",
  searchByNamePlaceholder: "Search by Name",
  searchByEmailPlaceholder: "Search by Email",
  leadAgent: {
    autopilot: {
      title: "Autopilot",
      reason: {
        silent: "No reply on WhatsApp for 2 days",
        never_answered: "Never answered on WhatsApp",
        undeliverable: "WhatsApp not deliverable",
        landline: "Landline number, no WhatsApp",
        invalid: "Invalid number for WhatsApp",
        opted_out_whatsapp: "Opted out of WhatsApp",
        whatsapp_paused: "WhatsApp conversation paused",
        reactivation: "Reactivated old request",
        callback_requested: "Callback requested",
        later: "Back with the Autopilot (later)",
        team: "Handed to the Lead Service by the team",
        clarify: "Needs clarification"
      },
      ended: "Autopilot switched off – status from the chat",
      nothingClarified: "Nothing clarified in the chat yet",
      // am_autopilot lib/reactivation.js OUTCOMES
      reactivationOutcome: {
        current: "Still current",
        questions: "Questions about the offer",
        considering: "Needs more time",
        second_look: "Wants to talk after all",
        plan_ahead: "Planning ahead",
        clarify: "Needs clarification",
        no_answer: "No answer",
        undeliverable: "Not deliverable"
      },
      answered: "Already answered",
      open: "Still open",
      unsure: "Clarify in the appointment",
      source: {
        funnel: "Funnel",
        whatsapp: "WhatsApp",
        phone: "Phone",
        earlier: "Earlier request"
      },
      chatSummary: "WhatsApp chat",
      photos: "Photos sent",
      photosYes: "yes ({{count}})",
      photosNo: "no",
      earlierAnswers: "From the earlier request",
      budget: "Budget",
      budgetTooLow: "too low, lead not suitable",
      book: "Book appointment",
      callFirst: "Start the call first.",
      freeSlots: "Free times",
      type: { PHONE: "Phone", ONSITE: "On site", SHOWROOM: "Showroom" },
      noSlots: "No free times in the business calendar.",
      address: {
        streetName: "Street",
        buildingNumber: "No.",
        postalCode: "Postcode",
        city: "City"
      },
      email: "Email of the customer",
      showroom: "Appointment in the showroom: {{address}}",
      answerOpenFirst:
        "Answer the open questions or mark them for the appointment.",
      confirmBooking: "Book now",
      booked:
        "Appointment booked: {{when}}. The customer gets the confirmation on WhatsApp or by SMS.",
      wishNoted: "Preferred time noted: {{when}}. The business confirms it.",
      bookingError: {
        SLOT_TAKEN: "This time was taken just now. Please choose another one.",
        BUDGET_TOO_LOW:
          "Budget too low – no appointment. Please mark the lead as not suitable.",
        ADDRESS_MISSING: "The address is missing.",
        EMAIL_MISSING: "The calendar needs the customer's email."
      },
      actionRunning:
        "Another action on this lead is still running. Please wait a moment.",
      unreachable: "Autopilot not reachable, please try again",
      retry: "Try again",
      laterHint: "The Autopilot contacts the customer on WhatsApp on this day."
    },
    interview: {
      heading: "AI interview (homeowner)",
      slots: {
        beschreibung: "Project description",
        umfang: "Scope",
        zeitrahmen: "Timeframe",
        kaufreife: "Decision stage",
        budget: "Budget",
        erreichbarkeit: "Best reachability"
      },
      details: "Further details",
      showQa: "Show full Q&A ({{count}})",
      hideQa: "Hide full Q&A"
    },
    loadMore: "Load More",
    searchBy: "Search by",
    companyLocation: "Company Location",
    distanceToCustomer: "Distance to Customer",
    calcDistance: "Calculate Distance",
    postalCodeMissingMsg: "Postal code is missing",
    callInProgress: "Call Inprogress",
    callContact: "Call Contact",
    calling: "Calling...",
    sending: "Sending...",
    completing: "Completing...",
    complete: "Complete",
    wrongNum: "Wrong Number",
    notReached: "Not Reached",
    wrongName: "Name Wrong",
    sendContactToCustomer: "Send contact to customer",
    leadInfo: "Lead Information",
    interestedParty: "Interested Party",
    enterValue: "Enter Value",
    dateOfRegistration: "Date of registration",
    speedDial: "Speed Dial",
    availableDaily: "Available Daily",
    enterComment: "Enter comment",
    qualified: "Qualified",
    notSuitable: "Not Suitable",
    appointmentWitHtheCustomer: "Make an appointment with the customer",
    appointmentInCalendy: "Book an appointment in Calendy",
    noLeads: "No lead to show",
    already: "Already",
    successfullyQualified: "Successfully qualified.",
    notQualifiedYet: "Not qualified yet.",
    available: "Available",
    after: "After",
    callAnyway: "Call anyway",
    interactingWithAnotherAgent: "Interacting with",
    leadServicePlusWarning:
      "Attention: This lead is processed with the Leadservice+",
    notes: "NOTES",
    notesPlaceholder: "Add a note or comment for the customer...",
    emailsToSendHeading: "Emails To Send",
    alreadyTakenMsg: "This Lead has been taken by another agent!",
    allOpenLeadsContactedMsg:
      "All open leads contacted by Funnel <strong>{{funnelName}}</strong>",
    noAppointmentForFunnel:
      "No Upcoming Lead Appointments within 24hrs for Funnel <strong>{{funnelName}}</strong>",
    mandatoryLeadServiceAnswersRequired:
      "Please answer all mandatory Lead Service questions before qualifying the lead.",
    mandatoryLeadServiceAnswersTooltip:
      "Open questions must be answered first.",
    noLeadsYetTooltip: "No leads yet!",
    backToNormalBtn: "Back To Normal",
    contactLater: "Contact lead later",
    contactLaterDialogHeading: "When should this lead be contacted?",
    contactLaterPastDateError: "The selected date cannot be in the past.",
    cancelling: "Cancelling...",
    cancelled: "Appointment Cancel",
    confirming: "Comfirming...",
    confirmed: "Appointment Confirm",
    postponed: "Date Postponed",
    appointmentDialogHeading: "Date and Time For Appointment",
    businessTimeLabel: "Time in German time",
    businessTimeSummary: "{{weekday}}, {{dateTime}}, German time",
    businessTimeHint:
      "This computer is not set to German time ({{zone}}). Enter the time exactly as agreed with the lead, in German time.",
    appointmentTimeInvalid:
      "This time does not exist on that day (clock change). Please choose another time.",
    // noUpcomingAppointment: "No Upcoming Lead Appointments within 24hrs",
    appointmentTaken: "Appointment Taken",
    appointmentNotTaken: "Appointment Not Taken",
    question: "QUESTION",
    answer: "Answer",
    noConfirmation: "Not for Appointment Confirmation",
    appointmentType: "Type of Appointment",
    individualNoteWarning: "This lead has special arrangements",
    warningPopupTitle: "Warning",
    saveAppointment: "Save appointment",
    forwardWithoutAppointmnet: "Forward without appointment",
    postponedTill: "Marked as unavailable for 2 hours",
    aiLeadserviceClosedTitle: "Sent to AI LeadService",
    aiLeadserviceClosedMessage:
      "This lead is being handled by the AI LeadService. Take it over to stop AI processing and make manual actions available again.",
    aiLeadserviceClosedNext: "Go to next lead",
    aiLeadserviceClosedToast:
      "This lead is already handled by AI LeadService. Loading the next lead.",
    aiLeadserviceTakeover: "Take over lead",
    aiLeadserviceTakingOver: "Taking over...",
    aiLeadserviceTakeoverError:
      "The AI LeadService could not be stopped. Please retry."
  },
  appointmentTypes: {
    onSiteAtLeadAddress: "Onsite at Lead Address",
    onSiteAtCompanyAddress: "Onsite at Company Address",
    phoneAppointment: "Phone Appointment",
    required: "Please select one of these options"
  },
  leadActivities: {
    title: "Activities",
    noActivityMsg: "No activities for this lead till now!",
    noteTooltip: "Note",
    agentInfo: "Agenten Info",
    // enums
    type: {
      CALL: "Call",
      SMS: "SMS",
      EMAIL: "Email",
      RESET: "Reset",
      SYNC_MANUALLY: "Manual Sync",
      PARTIAL_SYNC_MANUALLY: "Manual Sync Partially",
      DIGITAL_VERIFICATION: "Digital Verification",
      APPOINTMENT: "Appointment",
      LEAD_RESUBMISSION: "Lead Resubmission",
      AI_LEADSERVICE_HANDOFF: "Handed over to AI LeadService",
      AI_LEADSERVICE_MANUAL_TAKEOVER: "AI LeadService Takeover",
      MANUAL_LEAD_SERVICE_REMOVAL: "Manual removal from the lead service",
      AUTOPILOT: "Autopilot"
    },
    resultType: {
      NUMBER_WRONG: "Number incorrect",
      NAME_WRONG: "Name incorrect",
      COMPLETED: "Data correct",
      CALL: "Call",
      CALL_NOT_INITIATED: "Call not initiated",
      QUALIFIED: "Lead is qualified",
      NOT_SUITABLE: "Lead is not suitable",
      NOT_REACHED: "Not reached",
      RESET_SUCCESS: "Reset by admin",
      SYNCED_MANUALLY: "Manually Synced",
      CONTACT_LATER: "Contact lead later",
      APPOINTMENT_CALL: "Appointment Confirmation Call",
      APPOINTMENT_CANCELLED: "The appointment was cancelled",
      APPOINTMENT_CONFIRMED: "The appointment was confirmed",
      APPOINTMENT_POSTPONED: "The appointment was postponed",
      APPOINTMENT_NOT_REACHED: "Not reached",
      APPOINTMENT_NOT_HANDLED: "Lead appointment not handled",
      DIGITALLY_VERIFIED: "Digitally Verified",
      DIGITAL_VERIFICATION_FALLBACK: "Digital Verification Fallback",
      AVAILABILITY_SUBMITTED: "Availability Submitted",
      APPOINTMENT_UPDATED: "Appointment Updated",
      LEAD_RESUBMITTED: "Lead Resubmitted",
      AI_LEADSERVICE_HANDED_OVER: "First AI call pending",
      AI_LEADSERVICE_TAKEN_OVER: "AI LeadService taken over manually",
      LEAD_SERVICE_REMOVED: "Removed from lead service",
      AUTOPILOT_APPOINTMENT: "Appointment released to Contact Cloud",
      AUTOPILOT_CLOSED: "Ended without appointment",
      AUTOPILOT_ENDED: "Autopilot switched off",
      AUTOPILOT_REACTIVATION: "Reactivated by the Autopilot"
    },
    callAttempt: {
      title: "Call attempt",
      appointmentTitle: "Appointment call attempt",
      result: "Result",
      attempt: "Attempt",
      startedAt: "Started at",
      completedAt: "Completed at",
      duration: "Duration",
      nextAttemptAt: "Next attempt",
      reason: "Reason",
      minute: "min",
      minutes: "min",
      seconds: "sec"
    },
    notInitiatedReason: {
      LEAD_UNAVAILABLE: "Lead is not available right now"
    },
    resubmissionDetails: {
      title: "Request resubmitted",
      item: "Item {{index}}",
      question: "Question",
      answer: "Answer",
      fields: {
        optimalAvailability: "Optimal Availability",
        changedAnswers: "Changed answers"
      }
    },
    systemActivity: {
      title: "System activity",
      at: "Time",
      reason: {
        MAX_CONTACT_ATTEMPTS_REACHED:
          "Maximum number of contact attempts reached"
      }
    }
  },
  adEvaluation: {
    creativeOverview: "Creative Overview",
    leadCount: "Number of leads",
    leadCost: "Cost per lead",
    budgetSpent: "Budget spent",
    qualified: "Qualified leads",
    suggestionGallery: "Suggestion Gallery",
    adLabel: "Ad Name",
    adsetLabel: "Adset Name",
    titlesLabel: "Titles",
    descriptionsLabel: "Descriptions",
    bodiesLabel: "Bodies",
    expandBtnLabel: "Expand"
  },
  funnelsEvaluation: "Funnels Evaluation",
  creativeDashboard: "Creative Dashboard",
  funnelDetailsOverview: "Funnel Details Overview",

  invalidIdErrorMessage: "Invalid ID",
  sendBackToAgentTitle: "Send this lead back to lead agent",
  sendBackToAgentMessage: `Do you really want to send this lead back to <strong>lead agent</strong>?`,
  tools: "Tools",
  linkedFunnels: "Linked Funnels",
  pricePerInvoiceUnitLabel: "Price per invoice unit",
  unitLabel: "Unit",
  preventReloadWarning: "Leave website? Your changes were not saved!",
  downloadAsCsv: "Download as CSV",
  suggestionGallery: {
    currentTabLabel: "Current Suggestions",
    upload: "Upload",
    uploadDialogHeading: "Upload new item for suggestion",
    uploadImage: "Upload Image",
    dropHere: "Drop Here",
    adLink: "Ad link",
    count: "Count",
    testedLinksButtonText: "The image has already been tested here",
    testedLinks: "Tested Links",
    addNewTestedLink: "Add new tested link",
    uploadedSuccessfully: "Uploaded Successfully!",
    noteLabel: "Note",
    linkToCampaignLabel: "Link to Campaign",
    linkToFunnelLabel: "Link to Funnel",
    archiveModal: {
      heading: "{{what}} Suggestion",
      msg: `Are you sure you want to <strong class="text-danger">{{what}}</strong> this suggestion?`,
      multiHeading: "{{what}} Suggestions",
      multiMsg: `Are you sure you want to <strong class="text-danger">{{what}}</strong> these suggestions?`
    },
    winningModal: {
      mark: "mark",
      remove: "remove",
      msg: `Are you sure you want to {{what}} this suggestion as winning one?`
    }
  },
  countries: {
    title: "Countries",
    intro:
      "Countries offered in the funnel country selection. Changes apply to all workspaces.",
    addCountry: "Add country",
    addAnotherCountry: "Add another country",
    editCountry: "Edit country",
    actions: {
      edit: "Edit",
      hide: "Hide",
      show: "Show"
    },
    chooseMapImage: "Choose map image",
    errors: {
      nameRequired: "Please enter a name",
      nameTaken: "Name is already taken",
      countryRequired: "Please select at least one country",
      dialCodeRequired: "Please enter a dial code",
      dialCodeFormat: "Enter the dial code in the format +49",
      digitsRequired: "Please enter at least one postal code length",
      digitsFormat: "Postal code lengths must be whole numbers from 3 to 10",
      mapRequired: "Please choose a map image"
    },
    columns: {
      name: "Name",
      countries: "Countries",
      dialCode: "Dial code",
      postalCodeDigits: "Postal code digits",
      mapImage: "Map image",
      status: "Status"
    },
    bundledMap: "Bundled",
    statusActive: "Active",
    statusHidden: "Hidden"
  },
  formDefaults: {
    title: "Form defaults",
    intro:
      "Global defaults of the classic order form per funnel type. Split-test winners for colours and trust elements land here; funnels follow them unless they carry their own value.",
    submitButtonBackground: "Button colour",
    formHeaderBackground: "Header colour",
    hardCoded: "default",
    followsDefault: "follows the global default",
    socialProof: "Social-proof line (real requests of the category)",
    googleRating: "Google rating of the company",
    templateHint: "Placeholders {{count}} (required) and {{category}}.",
    minCount: "Show from (requests)",
    windowDays: "Window (days)",
    minRating: "Minimum rating",
    minReviews: "Minimum reviews",
    stateDefault: "Default (Site Settings)",
    stateOn: "On",
    stateOff: "Off",
    lastSet: "last set {{date}}",
    bySplitTest: "by split test",
    saved: "Form defaults saved"
  },
  fulfillmentKpis: {
    title: "Fulfillment KPIs",
    intro:
      "Monthly values of the last {{months}} months and the running month. The numbers are recalculated at most every {{minutes}} minutes.",
    running: "running",
    target: "Target {{value}} %",
    customer: "Customer",
    loadError: "The KPIs could not be loaded.",
    retry: "Load again",
    campaign: {
      title: "Campaign start within {{days}} days",
      help: 'First contracts in HubSpot (Fulfillment pipeline, no upsell) whose campaign was switched on ("Kampagne aktiv Datum") at most {{days}} days after the contract date. Month = contract month.',
      tile: "Campaign start within {{days}} days · {{month}} · target {{target}} % · median {{median}} days",
      series: "Share started in time",
      tooltip:
        "First contracts: {{cohort}} · in time {{inTime}} · later {{late}} · not started {{notStarted}} · open {{open}}",
      withoutTitle:
        "First contracts without campaign start (from day {{days}})",
      deal: "HubSpot deal",
      contractDate: "Contract date",
      days: "Days since contract",
      stage: "Stage",
      noAccess:
        "HubSpot is not connected: the Cockpit has no read access to HubSpot deals yet.",
      unavailable: "HubSpot could not be read. Please try again later.",
      truncated:
        "Not all first contracts could be read from HubSpot. The share and the list are incomplete."
    },
    start: {
      title: "First lead within {{days}} days",
      help: "New customers from HubSpot whose first lead arrives at most {{days}} days after they were created in the Cockpit. Month = month of creation.",
      tile: "First lead within {{days}} days · {{month}} · median {{median}} days",
      series: "Share with the first lead in time",
      tooltip:
        "New customers: {{cohort}} · in time {{inTime}} · later {{late}} · no lead yet {{notStarted}} · open {{open}}"
    },
    withoutStart: {
      title: "New customers without a first lead (from day {{days}})",
      createdAt: "Created on",
      days: "Days since creation",
      funnels: "Funnels",
      funnelCount: "{{count}} ({{drafts}} draft)"
    },
    leads: {
      title: "Customers with ≥ {{min}} leads",
      help: "Customers with at least one lead handed over to ContactCloud in the month, from their first full month.",
      tile: "≥ {{min}} leads · {{month}} · {{customers}} customers",
      tileTarget: "≥ {{min}} leads (target)",
      series: "≥ {{min}} leads",
      tooltip: "Customers in the month: {{customers}}"
    },
    below: {
      title: "Customers below {{min}} in the running month",
      running: "Leads running month",
      previous: "Leads previous month"
    }
  },
  splitTests: {
    title: "Split tests",
    intro:
      "One element of the order form (text, colour or trust element) is tested across all funnels of this type (50/50 per visitor). A significant winner is rolled out automatically; the next proposal follows.",
    tabs: { lead: "New customers", employee: "Employees" },
    variant: { A: "Control (current)", B: "Variant" },
    status: {
      PROPOSED: "Proposed",
      RUNNING: "Running",
      WON: "Won",
      LOST: "Lost",
      NO_DIFFERENCE: "No difference",
      CANCELLED: "Cancelled",
      REVERTED: "Reverted"
    },
    log: {
      STARTED: "Test started",
      CONTINUE: "Look evaluated, not significant yet",
      WON: "Variant B wins",
      LOST: "Control A wins",
      NO_DIFFERENCE: "No difference, control stays",
      CANCELLED: "Cancelled",
      REVERTED: "Roll-out reverted"
    },
    types: { text: "Texts", color: "Colours", feature: "Elements" },
    feature: { on: "on", off: "off" },
    fields: {
      element: "Element",
      controlValue: "Control text (A)",
      variantValue: "Variant text (B)",
      controlColor: "Current colour (A)",
      variantColor: "Variant colour (B)",
      template: "Social-proof template (B)",
      hypothesis: "Hypothesis",
      rationale: "Rationale",
      mde: "Minimum detectable effect (relative)"
    },
    running: {
      title: "Running test",
      since: "Started {{date}} · running {{days}} days",
      eligible: "{{count}} eligible funnels",
      log: "Decision log",
      emptyTitle: "No test is running",
      emptyText: "Start the proposal below or create a test manually."
    },
    stats: {
      exposures: "Form views",
      conversions: "Leads",
      rate: "Conversion",
      lift: "Lift B vs. A",
      ci: "95 % CI",
      pValue: "p-value",
      threshold: "significant below 0.0294 (two looks)",
      sampleSize: "Visitors per variant",
      baseline: "from {{rate}} baseline, +{{mde}} effect",
      sampleAfter48h: "fixed 48 h after the start",
      projectedDays: "Days to next look",
      lookOf: "Look {{look}} of 2",
      progress: "{{current}} of {{target}} visitors in the smaller variant",
      rule: "Decision at n and 2n visitors per variant, at least 7 days, at most 28 days."
    },
    proposal: {
      section: "Next proposal",
      title: "Next proposal",
      editTitle: "Edit proposal",
      manualTitle: "Create test manually",
      empty:
        "No proposal yet. Let the AI suggest the next element or create a test yourself.",
      waitForRunning:
        "A test is running for this funnel type. The next test can start once it has ended.",
      noEligible:
        "No live funnel carries this control text, so the test would reach nobody. Choose another control text.",
      sourceAi: "AI proposal",
      sourceManual: "Manual",
      baselineHint: "{{count}} live funnels",
      funnels: "funnels",
      mdeShort: "MDE +{{mde}} %",
      sampleShort: "≈ {{n}} visitors per variant",
      colorControlHint:
        "The current global default of the funnel type (or the hard-coded colour); funnels with their own colour do not take part.",
      featureControlHint:
        "Control = element off (current default), variant = element on. Only funnels that follow the default and can show the element take part.",
      featureEligible: "{{count}} funnels can show the element today.",
      sampleEstimate:
        "≈ {{n}} visitors per variant at {{rate}} baseline conversion (the exact number is fixed 48 h after the start)."
    },
    history: {
      title: "History",
      texts: "Texts",
      result: "Result",
      runtime: "Runtime",
      rollout: "Rolled out",
      visitors: "visitors",
      days: "days",
      rolledOutTo: "{{funnels}} funnels, {{templates}} templates",
      rolloutPending: "Roll-out failed, retry needed",
      emptyTitle: "No finished tests yet",
      emptyText: "Finished tests appear here with lift, p-value and roll-out."
    },
    actions: {
      propose: "Generate proposal",
      proposeAgain: "New proposal",
      createManual: "Create manually",
      edit: "Edit",
      start: "Start test",
      cancel: "Cancel test",
      evaluateNow: "Evaluate now",
      preview: "Preview",
      revert: "Revert roll-out",
      retryRollout: "Retry roll-out"
    },
    confirm: {
      startTitle: "Start split test?",
      startText:
        "Element {{element}} will be tested 50/50 on {{count}} live funnels. The winner is rolled out automatically.",
      cancelTitle: "Cancel split test?",
      cancelText: "The test ends without a decision. Nothing is rolled out.",
      revertTitle: "Revert roll-out?",
      revertText:
        "The control text is restored on {{funnels}} funnels (and the templates) that still carry the winner text.",
      rolloutTitle: "Retry roll-out?",
      rolloutText:
        "The winner text is written to every live funnel (and template) of this type that still carries the control text."
    },
    toast: {
      proposed: "Proposal generated",
      created: "Test created",
      saved: "Proposal saved",
      started: "Test started",
      cancelled: "Test cancelled",
      stillRunning: "Evaluated: no decision yet, the test keeps running",
      decided: "Decision: {{status}}",
      reverted: "Roll-out reverted",
      rolledOut: "Roll-out done: {{funnels}} funnels, {{templates}} templates"
    }
  },
  leadservicePanel: {
    onHoldHeading: "On Hold",
    onHoldInfoMsg: "Leads on hold",
    currentlyDisabledWarning:
      "Leadservice of this Funnel is currently disabled",
    leadService: "Lead Service",
    appointment: "Lead Appointments"
  },
  aiLeadservice: {
    lead: {
      heading: "AI Leadservice (LEAD - New Customers)",
      enabledSuccess: "AI Leadservice (LEAD) enabled updated",
      enabledError: "Failed to update AI Leadservice (LEAD) enabled",
      webhookSuccess: "AI Leadservice (LEAD) webhook updated",
      webhookError: "Failed to update AI Leadservice (LEAD) webhook",
      triggerSuccess: "AI Leadservice (LEAD) trigger updated",
      triggerError: "Failed to update AI Leadservice (LEAD) trigger"
    },
    employee: {
      heading: "AI Leadservice (EMPLOYEE - Employee Recruitment)",
      enabledSuccess: "AI Leadservice (EMPLOYEE) enabled updated",
      enabledError: "Failed to update AI Leadservice (EMPLOYEE) enabled",
      webhookSuccess: "AI Leadservice (EMPLOYEE) webhook updated",
      webhookError: "Failed to update AI Leadservice (EMPLOYEE) webhook",
      triggerSuccess: "AI Leadservice (EMPLOYEE) trigger updated",
      triggerError: "Failed to update AI Leadservice (EMPLOYEE) trigger"
    },
    webhookIntegrationLabel: "Webhook Integration",
    webhookUrlLabel: "Webhook URL",
    attemptsLabel: "After how many attempts",
    trackingGlobalHeading: "Lead Service Tracking Global"
  },
  leadserviceReport: {
    label: "Slack webhook daily report (Mon–Fri 18:00)",
    configured: "configured",
    notConfigured: "not configured",
    updatedAt: "changed {{date}}",
    hint: "Incoming webhook of the leadservice Slack channel, or a Zapier catch hook that forwards to it. The URL is stored securely and is not shown again.",
    saved: "Slack webhook saved",
    remove: "Remove",
    removeConfirm:
      "Remove the stored webhook? The daily report will not be posted until a new one is saved.",
    removed: "Webhook removed",
    removeError: "Webhook could not be removed",
    saveError: "Slack webhook could not be saved",
    sendTest: "Send test message",
    testSent: "Test message sent — please check the Slack channel",
    testNotSent: "Test message could not be sent"
  },
  adLinkPlaceholder: "Insert link to advertising account",
  uploadScriptDialog: {
    uploadPDF: "Upload PDF"
  },
  textElementsTelephoneCheck: {
    switchLabel: "Enable telephone number with two steps",
    screenHeadline: "Telephone Screen Headline"
  },
  textElementsImageCheck: {
    switchLabel: "Enable Form Image",
    fieldLabel: "Form Image",
    placementRadioLabel: "Form Image Placement",
    radioBeforeLabel: "Before Form Subheadline",
    radioAfterLabel: "After Form Subheadline"
  },
  leadTabs: {
    leads: "Leads",
    incompleteLeads: "Incomplete Leads",
    numberOfEmailsSentLabel: "Number of Emails sent"
  },
  customerTabs: {
    customer: "Customers",
    cockpitCustomers: "Customers",
    hubSpotCustomers: "Hubspot Customers"
  },
  policySection: {
    switchLabel: "Display Policy Section",
    toBeShownTooltip: "Policy Section will be shown",
    notToBeShownTooltip: "Policy Section will not be shown",
    textFieldPlaceholder: "Enter text for display as policy text",
    checkboxText: "Checkbox Text",
    clickableKeyword: "Clickable Keyword",
    modalContent: "Modal Content"
  },
  incompleteLeadDialog: {
    title: "Delete Incomplete Lead",
    msg: "Do you want to <strong>delete</strong> this?"
  },
  editorModal: {
    deleteConfirmationMsg:
      "Are you sure you want to <strong>delete</strong> the {{what}}?"
  },
  preLandingPage: {
    duplicateLabel: "Duplicate",
    duplicateSubLabel: "Duplicate pre landing page template to any funnel.",
    duplicateSuccessMsg: `Pre landing page for Funnel {{funnelName}} duplicated successfully!`,
    duplicateDisabledTooltip: "Your changes are not saved!",
    sameFunnelWarning: "You are currently standing on same funnel",
    enableSwitchLabel: "Enable Landing Page",
    enableSwitchDialogMsg: `Are you sure you want to <strong class="text-danger">enable</strong> landing page?`,
    disableSwitchDialogMsg: `Are you sure you want to <strong class="text-danger">disable</strong> landing page?`,
    selectTemplateLabel: "Select Template",
    templateOneOptLabel: "Template 1 (Image/Text - one below the other)",
    templateTwoOptLabel: "Template 2 (Image/Text - side by side)",
    deletePointMessage: `Are you sure you want to <strong class="text-danger">delete</strong> this Point?`,
    deletePointSuccess: "Hero Content Point deleted successfully.",
    deleteBenefitMessage: `Are you sure you want to <strong class="text-danger">delete</strong> this Benefit?`,
    deleteBenefitSuccess: "Benefit deleted successfully."
  },
  preLandingPageOne: {
    headerBgColorLabel: "Header Background Color",
    headlineTextLabel: "Headline Text",
    headlineColorLabel: "Headline Color",
    heroHeadlineTextLabel: "Hero Headline Text",
    heroHeadlineTextColorLabel: "Hero Headline Text Color",
    heroContentLabel: "Hero Content",
    heroImageLabel: "Hero Image",
    ctaButtonTextLabel: "CTA Button Text",
    ctaButtonTextColorLabel: "CTA Button Text Color",
    ctaButtonBackgroundColor: "CTA Button Background Color",
    benefits: {
      benefitsGridHeadline: "Benefits Grid Headline",
      benefitsGridHeadlineColor: "Benefit Headline Color",
      benefitsGridTextColor: "Benefit Text Color",
      benefitsGridSubHeadline: "Benefits Grid Sub Headline",
      benefitsGridLabel: "Benefits Grid",
      addNewBenefitBtn: "Add benefit",
      label: "Label",
      subtext: "Subtext",
      icon: "Icon",
      selectBtn: "Select"
    },
    footerContent: "Footer Content"
  },
  preLandingPageTwo: {
    backgroundImageLabel: "Background Image",
    centerContentBackgroundColorLabel: "Center Content Background Color",
    centerContentBackgroundOpacityLabel: "Center Content Background Opacity",
    contactUsButtonTextLabel: "Contact Us Button Text",
    contactUsButtonColorLabel: "Contact Us Button Color",
    contactUsButtonBackgroundHoverLabel: "Contact Us Button Background Hover",
    phoneNumberHeadlineLabel: "Phone Number Headline",
    phoneNumberTextLabel: "Phone Number Text",
    phoneNumberColorLabel: "Phone Number Color",
    subHeadlineTextLabel: "Sub-Headline Text",
    subHeadlineColorLabel: "Sub-Headline Color",
    heroContentLabel: "Hero Content",
    heroImageLabel: "Hero Image",
    heroPoints: {
      headingLabel: "Bullet Points Next To Hero Image (maximum 3)",
      btnLabel: "Add Bullet Points next to image",
      label: "Label",
      text: "Text"
    },
    footerMapLabel: "Footer Embedded Map URL",
    heroContentTextColorLabel: "Hero Content Text Color",
    heroContentIconColorLabel: "Hero Content Icon Color"
  },
  customerWebsite: {
    website: "Website",
    duplicate: "Duplicate",
    brandColors: {
      heading: "Brand Colors",
      warning:
        "Changing any brand color will overwrite the preset values below, including any previously customized colors for headings or text",
      headingDark: "Heading Dark",
      headingLight: "Heading Light",
      textPrimary: "Text Primary",
      textSecondary: "Text Secondary",
      textLight: "Text Light",
      buttonPrimary: "Button Primary",
      buttonSecondary: "Button Secondary",
      buttonBGPrimary: "Button Background Primary",
      buttonBGSecondary: "Button Background Secondary",
      primaryBG: "Primary Background",
      secondaryBG: "Secondary Background"
    },
    sections: {
      hero: "Hero",
      about: "About",
      service: "Service",
      banner: "Banner",
      keyPoint: "Key Point",
      secondBanner: "Second Banner",
      map: "Map",
      faq: "Faqs"
    },
    section: "Section",
    addSection: "Add New Section",
    deleteSection: "Delete Section",
    deleteSectionMessage: "Do you really want to delete this section?",
    deleteFavicon: "Delete Favicon",
    deleteFaviconMessage:
      "Are you sure you want to delete the favicon? This action is irreversible and the favicon will be permanently removed.",
    selectSection: "Select Section",
    logo: {
      heading: "Logo",
      logoType: "Logo Type",
      logoText: "Logo Text",
      logoColor: "Logo Color",
      logoImage: "Logo Image",
      logoScale: "Logo Scale"
    },
    navLinks: "Nav Links",
    linksTextColor: "Links Text Color",
    link: "Link",
    text: "Text",
    contact: "Contact",
    phone: "Phone",
    phoneIconColor: "Phone Icon Color",
    address: "Address",
    addressIconColor: "Address Icon Color",
    template: "Template",
    preview: "Preview",
    header: "Header",
    BGColor: "Background Color",
    heading: "Heading",
    headingColor: "Heading Color",
    para: "Para",
    paraColor: "Para Color",
    bullet: "Bullet",
    bulletsColor: "Bullets Color",
    image: "Image",
    images: "Images",
    addImage: "Add Image",
    mobileSortingLogic: "Mobile Sorting Logic",
    mobileSortingHorizontal: "Horizontal (Rows)",
    mobileSortingVertical: "Vertical (Columns)",
    mobileSortingLogicTooltip:
      "Horizontal keeps the image order 1, 2, 3. Vertical lists the first desktop column first, for example 1, 4, 7.",
    ctaBtnText: "CTA Button Text",
    ctaBtnLink: "CTA Button Link",
    ctaBtnColor: "CTA Button Color",
    ctaBtnBGColor: "CTA Button Background Color",
    ctaBtnTwoText: "CTA Button 2 Text",
    ctaBtnTwoLink: "CTA Button 2 Link",
    ctaBtnTwoColor: "CTA Button 2 Color",
    ctaBtnTwoBGColor: "CTA Button 2 Background Color",
    BGImage: "Background Image",
    mapMessage: "Copy the iframe from the google map and paste here",
    mapLink: "Map Frame",
    qAndA: "Question & Answers",
    q: "Question",
    a: "Answer",
    add: "Add",
    addQ: "Add Question",
    qColor: "Question Color",
    aColor: "Answer Color",
    footer: "Footer",
    taglineText: "Tagline Text",
    taglineColor: "Tagline Color",
    fbLink: "Facebook Link",
    fbColor: "Facebook Icon Color",
    instaLink: "Instagram Link",
    instaColor: "Instagram Icon Color",
    ytLink: "Youtube Link",
    videoSwitch: "Show video instead of image",
    videoLink: "Video link (YouTube or Wistia)",
    videoLinkPlaceholder:
      "e.g. https://youtu.be/… or https://am-beratung.wistia.com/s/…",
    videoLinkHelp: "Wistia: click “Share” in Wistia and copy the link.",
    ytColor: "Youtube Icon Color",
    x_twitterLink: "X/Twitter Link",
    x_twitterColor: "X/Twitter Icon Color",
    pinterestLink: "Pinterest Link",
    pinterestColor: "Pinterest Icon Color",
    tiktokLink: "Tiktok Link",
    tiktokColor: "Tiktok Icon Color",
    linkedinLink: "LinkedIn Link",
    linkedinColor: "LinkedIn Icon Color",
    socialLinks: "Social Links",
    quickLinks: "Quick Links",
    policyLinks: "Policy Links",
    privacyPolicy: "Privacy Policy",
    legalNotice: "Legal Notice",
    agbSwitchLabel: "Enable AGB (optional)",
    legalPagesSwitchLabel: "Show as separate pages (instead of pop-up)",
    legalPagesHelp:
      "The texts are then available at {{urls}}. If a link is set under “Link”, the footer keeps opening that link.",
    legalPagesHelpNone:
      "No separate page yet: a legal text becomes a page once it has content and no link under “Link”.",
    legalPagesYourDomain: "your-domain.com",
    legalPageContentMissing: "Content is missing for the separate page.",
    reservedTabRoute: "This route is reserved for the legal pages.",
    tabRoutesLoadFailed:
      "The customer's tabs could not be loaded. The route is checked when saving.",
    name: "Name",
    nameColor: "Name Color",
    title: "Title",
    titleColor: "Title Color",
    email: "Email",
    emailColor: "Email Color",
    phoneColor: "Phone Color",
    saveWebsite: "Save Website",
    savingWebsite: "Saving Website",
    cloneDialogHeading: "Clone Template for another Customer",
    policies: "Policies",
    unclipImage: "Unclip Image",
    replaceWarning: {
      title: "Warning",
      para: "Do you want to overwrite the existing website of this customer?",
      btn: "Yes",
      saving: "Saving..."
    },
    btnSameBGColorError:
      "Button Text and Background color should have sufficient contrast",
    script: {
      label: "Script",
      head: "Head",
      body: "Body"
    },
    errors: {
      customerCreationError: "Error while creating hubspot customer",
      aiContentError: "Error while generating AI content"
    },
    RECEIVED: "Received",
    PROCESSING: "Processing",
    COMPLETED: "Completed",
    FAILED: "Failed",
    favIconSuggestionText: "Editable only in the Website Base tab",
    footerBanner: "Footer Banner",
    footerBannerLabel: "Show A&M footer banner"
  },
  versionDialogMsg: {
    changeVersionAndLandingPage:
      "<div>Landing page in this version is <strong>different</strong> from current version.</div><div>Do you want to continue and <strong>update</strong> the landing page?</div>",
    changeVersionAndDisableLandingPage:
      "<div>There is no pre-landing page linked in this version.</div><div>Should we <strong>deactivate</strong> the pre-landing page anyway?</div>",
    changeVersionAndEnableLandingPage:
      "<div>There is active pre-landing page linked in this version.</div><div>Should we <strong>activate</strong> the pre-landing page anyway?</div>",
    default: `Are you sure you want to <strong>activate</strong> this funnel version?`
  },
  deleteIntegration: "Delete Integration",
  disableLeadServiceModal: {
    heading: "Disable Lead Service",
    associatedIntegrationMsg: `This Lead Service is associated with <strong>{{count}} Leads</strong> that needs to be synced`,
    syncNowAndDisable: "Sync Now & Disable",
    disableNowAndSyncLater: "Disable Now & Sync Later"
  },
  lastTaskLabel: "Last Task",
  budgetSectionLabels: {
    lead: "Lead",
    employee: "Employee"
  },
  selectRangeLabel: "Select Range",
  tagform: {
    cancel: "Cancel",
    save: "Save",
    uneditableSystemTagMessage: "This is a system tag and can't be edited"
  },
  addressAfterLeadgen: {
    switchLabel: "Enable Address After Lead Generation",
    fieldLabel: "Address Label",
    fieldPlaceholder: "Enter Address Label",
    submitBtnFieldLabel: "Submit Address Button Label",
    submitBtnFieldPlaceholder: "Enter Submit Address Button Label"
  },
  campaignsReview: {
    title: "Campaigns Review",
    spend: "Spend",
    positive: "Positive",
    negative: "Negative",
    noStage: "No Stage",
    neutral: "Neutral"
  },
  lsTypeFilters: {
    all: "All Leads",
    leadService: "Lead Service",
    leadServicePlus: "Lead Service Plus",
    leadServicePlusWithAppointment: "Lead Service Plus with Appointment"
  },
  notSutablePie: {
    title: "Distribution of Not-Sutiable leads"
  },
  website: {
    analyticsHeading: "Analytics",
    keyMetrics: "Key Metrics",
    totalVisitCount: "Total Visit Count",
    uniqueVisitCount: "Unique Visit Count",
    totalCTAClicks: "Total CTA Clicks",
    totalNonCTAClicks: "Total Non-CTA Clicks",
    leads: "Leads",
    funnels: "Funnels",
    assignFunnels: "Assign Funnels",
    noFunnelsAssigned: "No funnels assigned yet",
    noWebsiteFound: "No website found",
    ctaConversionRate: "CTA Conversion Rate",
    leadConversionRate: "Lead Conversion Rate",
    visitsWithoutCtaClick: "Visits without CTA Click",
    visitsWithoutLead: "Visits without Lead",
    CTAInfo: "CTA Info",
    nonCTAInfo: "Non-CTA Info",
    allTime: "All time",
    footerEmail: "Footer Email",
    footerPhone: "Footer Phone",
    navbarPhone: "Navbar Phone",
    navbarPhoneTwo: "Navbar Phone 2",
    footerContact: "Footer Contact",
    footerContactTwo: "Footer Contact 2"
  },
  localSeo: {
    pageTitle: "Local SEO",
    submitBtn: "Create Local SEO Content",
    locationLabel: "Cities",
    locationPlaceholder: "Enter city",
    addNewLocationBtn: "Add another city",
    serviceKeywordLabel: "Keywords / Product",
    serviceKeywordPlaceholder: "Enter keyword or product",
    addNewKeywordBtn: "Add another service",
    delDialogHeading: "Confirm Delete",
    renderDelGeneratedCityDialogMsg:
      "Deleting this city will remove it and all associated generated subpages. Are you sure you want to continue?",
    populateCustomerCityLabel: "Populate from customer",
    deleteGeneratedFieldMsg:
      'Warning: Deleting this <span class="fw-bold">item</span> will <span class="fw-bold text-danger">also delete</span> its corresponding sub-pages.',
    renderDelGeneratedSubPageDialogMsg:
      "Are you sure, you want to delete this generated sub-page?",
    progressCompleted: "Completed",
    progressStarting: "Starting",
    progressRetrying: "Retrying",
    progressRetrySuccess: "Retry success",
    failed: "Failed",
    retry: "Retry",
    successful: "Successful",
    retryDialogHeading: "Retry Confirmation",
    retryDialogMsg: "This sub page was not generated, do you want to retry?",
    editPageTitle: "Page Title",
    seoTitle: "SEO Title",
    seoDescription: "SEO Description",
    sections: "Sections",
    heading: "Heading",
    paragraph: "Paragraph",
    renderDelNonGeneratedSubPageDialogMsg:
      "This page was not generated. Are you sure you want to delete this?"
  },
  exportQueries: {
    notSuitableExportDescription:
      "Export a CSV file of not-suitable leads from the last 90 days, filtered by specific reasons and categories while excluding certain zip codes and tenant IDs."
  },
  privacyPolicy: {
    activateLabel: "Activate Hausflix Privacy Form",
    tabName: "Hausflix Data Protection",
    checkboxTextLabel: "Checkbox Text",
    clickableKeywordLabel: "Clickable Keyword",
    modalHeadingLabel: "Modal Heading",
    modalContentLabel: "Modal Content"
  },
  offerFollowupAgent: {
    outcomes: {
      suitable: "Qualified",
      not_suitable: "Not suitable",
      callback_required: "Contact lead later",
      not_reached: "Not reached"
    },
    call: "Call",
    nextAttempt: "Next attempt:",
    nextAttemptAfter: "Next attempt after: {{date}}",
    activityCreatedAt: "Created At:",
    noActivities: "No activities for this lead yet.",
    calling: "Calling...",
    errors: {
      loadLead: "Unable to load offer follow-up lead",
      startCall: "Unable to start call",
      invalidDecision: "Invalid decision",
      notesLength: "Agent notes must be at least 20 characters.",
      callbackTime: "Next attempt must be at least 4 hours from now.",
      callNotAllowedYet: "This lead can be called after {{date}}.",
      saveOutcome: "Unable to save follow-up outcome",
      searchLeads: "Unable to search offer follow-up leads"
    },
    saved: "Offer follow-up saved.",
    emptyQueue: "No pending offer follow-up leads.",
    refreshQueue: "Refresh queue",
    searchBy: "Search by",
    search: "Search",
    searchedBy: "Searched by: {{type}}",
    searchTypes: {
      phone: "Phone",
      email: "Email"
    },
    lead: "Lead",
    createdAt: "{{date}}",
    company: "Company",
    tenant: "CC tenant",
    offerSentAt: "Offer sent at",
    today: "(Today)",
    daysAgo_one: "(1 day ago)",
    daysAgo_other: "({{count}} days ago)",
    product: "Product",
    offerVolume: "Offer volume",
    callContact: "Call contact",
    callRestrictedNote: "This lead should be called after {{date}}.",
    notReached: "Not reached",
    contactLater: "Contact lead later",
    qualified: "Qualified",
    notSuitable: "Not suitable",
    notes: "Notes",
    notesPlaceholder: "Add a note or comment for the customer...",
    minimumCharacters: "{{count}}/20 minimum characters",
    selectedCallbackDate: "Selected callback: {{date}}",
    saveAndComplete: "Save & complete",
    contactHistory: "Contact history",
    createdBy: "Created by:",
    noContactHistory: "No Contact Cloud history available for this lead.",
    activities: "Activities",
    script: "Script"
  },
  agentRouteSwitch: {
    title: "Switch agent queue?",
    message:
      "Do you want to switch to {{target}}? Your current assignment will be released and you will be assigned to the next queue.",
    continue: "Continue",
    stay: "Stay here",
    releaseError: "Unable to release the current assignment.",
    activeCallError:
      "Please finish the current call before opening another panel."
  },
  removeFromLeadserviceBtn: "Remove from leadservice",
  removeFromLeadserviceConfirmationMsg:
    "Are you sure you want to remove this lead from the lead service?"
};
export const DE = {
  adName: "Bild",
  averageCalls: "Durchschnittliche Anrufe",
  funnelFilters: {
    multiPCHeading: "Einzubeziehende Standorte",
    multiPCCaption: "Zielen Sie auf mehrere Postleitzahlen",
    multiPCPlaceHolder: "Geben Sie die Postleitzahlen zeilenweise getrennt ein",
    clearAll: "alles löschen",
    addLocations: "Standorte hinzufügen",
    germany: "Deutschland",
    switzerland: "Schweiz",
    austria: "Österreich",
    selectedCodesHeading: "Ausgewählte Postleitzahlen",
    saveBtn: "Funnel Filters Speichern"
  },
  leadpannel: {
    leadCountTitle: "Leadservice Kennzahlen",
    leadRateTitle: "Lead-Rate",
    syncedLeads: "Synchronisierte Leads",
    unsyncedLeads: "Nicht synchronisierte Leads",
    totalLeads: `Gesamtzahl <br /> Leads`,
    appointmentChartTitle: "Terminverfolgung",
    openAppointments: "Offene Lead-Termine",
    handledLeads: "Erreichte Leads",
    callsMade: "Gesamt Gemachte Anrufe",
    confirm: "Termine Bestätigt",
    cancel: "Termine Abgesagt",
    postpone: "Termin Verschoben",
    notReached: "Nicht Erreicht",
    notHandled: "Nicht zur Bestätigung erreicht"
  },
  invoice: {
    heading: "Rechnungen",
    invoiceNumber: "Rechnungsnummer",
    invoiceDate: "Rechnungsdatum",
    invoiceAmount: "Betrag",
    status: "Status",
    download: "Herunterladen",
    downloading: "Herunterladen...",
    preview: "Vorschau",
    opening: "Öffnung...",
    sendToCust: "Senden an Kunde",
    sending: "Sendet...",
    noInvoices: "Keine Rechnungen Gefunden",
    noInvoicesForYear: "Für dieses Jahr wurden keine Rechnungen gefunden",
    paid: "Bezahlt",
    issued: "Ausgestellt"
  },
  toastMessage: {
    templateAppliedSuccess: "Vorlage angewendet",
    disable2FAError: "Fehler beim Deaktivieren von 2FA!",
    verificationError: "Fehler bei der Verifizierung!",
    qrCodeError: "Fehler beim Erstellen des QR-Codes!",
    updateFBToken: "Fehler beim Aktualisieren des FB-Tokens!",
    selectAssetError: "Fehler bei der Auswahl des Assets!",
    funnelByDomain: "Fehler beim Laden des Funnels durch Domain & Sub-Domain!",
    updateLeadError: "Fehler beim Aktualisieren der Lead-Daten!",
    update: "Fehler beim Aktualisieren!",
    duplicateFunnelError: "Fehler beim Duplizieren des Trichters!",
    duplicateFunnelSuccess: "Funnel erfolgreich dupliziert!",
    duplicateFunnelWarning:
      "Dieser Funnel kann nicht dupliziert werden, da er unvollständige Informationen enthält!",
    noTenantIdWarning:
      "Es gibt keine Tenant-ID, du musst die Contact-Cloud-ID zu diesem Kundenfunnel hinzufügen!",
    createAssetError: "Fehler beim Erstellen des Assets!",
    createUserError: "Fehler beim Erstellen des Benutzers!",
    // assignUserTokenError: "Fehler beim Zuweisen des Benutzertokens!", // Translated by google
    fetchUsersError: "Fehler beim Abrufen der Benutzer!",
    updateUserError: "Fehler beim Aktualisieren des Benutzers!",
    downloadError: "Fehler beim Herunterladen des Bildes!",
    uploadItemError: "Fehler beim Hochladen des Artikels!",
    importFunnel: "Fehler beim Importieren des Trichters!",
    createTemplateError: "Fehler beim Erstellen der Vorlage!",
    archiveError: "Fehler im Archiv!",
    unarchiveError: "Fehler beim Entarchivieren!",
    assetsUploadError: "Fehler beim Hochladen von Assets",
    fbPagesError: "Fehler beim Abrufen der Facebook-Seiten!",
    draftFunnel: "Fehler beim Erstellen des Draft-Trichters!",
    draftTemplate: "Fehler beim Erstellen der Entwurfsvorlage!",
    deleteTemplate: "Fehler beim Löschen der Vorlage!",
    fbFormError: "Fehler beim Abrufen von Facebook-Seitenformularen!",
    wentWrong: "Etwas ist schief gelaufen!",
    categoryByName: "Kategorie nach Namen!",
    categoryByID: "Kategorie nach ID!",
    saveCategory: "Fehler beim Speichern der Kategorie!",
    changePassword: "Fehler beim Ändern des Passworts!",
    fetchInsightsError: "Fehler beim Abrufen von Erkenntnissen",
    saveCustomer: "Fehler beim Speichern des Kunden!",
    createCity: "Fehler beim Erstellen einer neuen Stadt!",
    updateFunnels: "Fehler beim Aktualisieren des Funnels!",
    updateTemplate: "Fehler beim Aktualisieren der Vorlage!",
    errorInGetting: "Fehler beim Erhalten von {{what}}!",
    errorInUpdating: "Fehler beim Aktualisieren von {{what}}!", // Translated by google
    updateFunnelFilters: "Fehler beim Aktualisieren der Trichterfilter",
    removeDomain: "Fehler beim Entfernen der Domain und Subdomain",
    fetchVersion: "Fehler beim Abrufen der Version!",
    changeVersion: "Fehler beim Versionswechsel!",
    downloadSuccessfully: "Erfolgreich Herunterladen!",
    csvDownloadError: "Fehler beim herunterladen csv!"
  },
  fbTokenInfoMessage:
    "Derzeit wird der Facebook-Token von <strong>{{what}}</strong> verwendet",
  availableAfter: "Nach wie vielen Stunden sind die Anfragen wieder verfügbar",
  offerFollowupMaxNotReachedAttempts:
    "Angebotsnachverfolgung: maximale Nicht-erreicht-Versuche",
  callingDownTimeLabel:
    "Nach wie vivelen Minuten ohne Anruf soll eine Warnung verschickt werden",
  createdLeads: "Anzahl erstellten Leads",
  numberOfVisits: "Anzahl der Besuche",
  outcome: {
    jumpDirect: "Direkt zu diesem Outcome springen",
    jumpEnd: "Erst am Ende zu diesem Outcome springen",
    restart: "Fragebogen neu starten"
  },
  settings: {
    welcome: "Willkommen in den Profileinstellungen:",
    connectFB: "Mit Facebook verbinden"
  },
  funnelIntegration: {
    autopilot: {
      title: "Autopilot",
      active: "Aktiv (im Autopilot geschaltet)",
      inactive: "Nicht aktiv",
      readOnly: "Der Autopilot schaltet sich selbst an und aus.",
      ccHint:
        "Autopilot aktiv: Anfragen gehen erst mit gebuchtem Termin in die Contact Cloud.",
      leadStatus: {
        WITH_AUTOPILOT: "Beim Autopilot (WhatsApp)",
        IN_LEADSERVICE: "Im Lead Service",
        RELEASED: "Termin an Contact Cloud übergeben am {{date}}",
        CLOSED: "Ohne Termin beendet",
        ENDED: "Autopilot abgeschaltet, normaler Lead"
      }
    },
    tabTitleActiveTooltip: "Hat aktiv integrations",
    tabTitleNotIntegratedTooltip: "Nicht integrated",
    error: "Fehler bei der Integration!",
    updateIntegration: "Fehler beim Aktualisieren der Integration!",
    removeIntegration: "Fehler beim Entfernen der Integration!",
    descriptionPlaceholder: "Integrationsbeschreibung hier hinzufügen",
    deleteIntegrationWarning: `Möchten Sie diese Integration <strong>löschen</strong>?`,
    deleteAppointmentLinkWarning: `Möchten Sie des treffen <strong>löschen</strong>?`,
    deleteAccountLinkWarning: `Möchten Sie diese werbekonto verknüpfung <strong>löschen</strong>?`,
    webhookPlaceholder:
      "Webhook-URL eingeben (diese Information bekommst du von Zapier)",
    updateToastMsg: "Integration erfolgreich aktualisiert!",
    enableDialogMsg:
      "Möchten Sie diese integration <strong>aktivieren</strong>?",
    disableDialogMsg:
      "Möchten Sie diese integration <strong>deaktivieren</strong>?",
    sendDataHeading: "Daten Senden",
    selectOptions: {
      never: "Nie",
      immediately: "Sofort senden",
      afterConfirmation: "Nach Bestätigung senden",
      leadServiceInfo: "Aktivieren Lead Service 2.0 zuerst!"
    },
    leadService: {
      enableDialogMsg:
        "Möchten Sie Lead Service 2.0 <strong>aktivieren</strong>?",
      disableDialogMsg:
        "Möchten Sie Lead Service 2.0 <strong>deaktivieren</strong>?",
      warningDialogMessage: `Wenn du den Lead-Service 2.0 deaktivierst, werden deine Einstellungen für das Senden von <strong>E-Mails</strong> an Kunden, <strong>contact cloud</strong> oder <strong>zapier</strong> integration beeinträchtigt!<div>Möchtest du fortfahren?</div>`,
      enablePlusMsg: "Möchten Sie Lead Service+ <strong>aktivieren</strong>?",
      disablePlusMsg:
        "Möchten Sie Lead Service+ <strong>deaktivieren</strong>?",
      leadServiceCompanyNameLabel: "Leadservice Unternehmensname",
      leadServiceProductNameLabel: "Produktname",
      individualNoteLabel: "Individualnotiz"
    },
    leadServicePlus: {
      priceTypeLabel: "Preistyp",
      calculationLabel: "Berechnung",
      fixedPriceLabel: "Festpreis",
      areaQueryLabel: "Bereichsabfrage",
      pricePerInvoiceUnitLabel: "Preis pro Rechnungseinheit",
      fixedPricePerInvoiceUnitLabel: "Festpreis pro Rechnungseinheit",
      nameOfAccountingUnitLabel: "Name Rechnungseinheit",
      specifyHerePlaceholder: "Hier angeben",
      budgetQueryLimitsLabel: "Grenzen für die Budgetabfrage",
      pricePerAreaLabel: "Preis pro Bereich",
      disabledBudgetLimitRadioMsg:
        "Hinzufügen Name Rechnungseinheit zu Aktivieren",
      removeUnitNameConfirmationMsg: `Wenn du den <strong>Name Rechnungseinheit</strong> entfernen, werden deine <strong>Preistyp</strong> für das <strong>Bereichsabfrage</strong> beeinträchtigt!<div>Möchtest du fortfahren?</div>`,
      optionalQuestion: "Optional Weiche Fragen",
      question: "Frage",
      budgetAreaOfQueryBounds: "Budgetbereich zur Abfrage",
      addAnotherOption: "Weitere Option hinzufügen",
      variantNamePlaceholder: "Optionsname",
      variantSelectLabel: "Gewünschte Option",
      variantSelectPlaceholder: "Option auswählen",
      variantNameRequired:
        "Alle Optionen benötigen einen Namen, sobald mehrere Optionen vorhanden sind.",
      uniqueVariantNameRequired: "Jeder Optionsname muss eindeutig sein.",
      invalidVariantPrice: "Jede Option benötigt einen gültigen Preis."
    },
    alternativeAddress: {
      checkboxLabel: "Abweichende Adresse",
      error: "Fehler beim Aktualisieren des Abweichende Adresse!"
    },
    email: {
      alertDialogMessage: `Entschuldigung, du musst zuerst den <strong>Lead-Service 2.0</strong> aktivieren!`,
      label: "E-Mail an Kunden senden",
      toastError:
        "Fehler beim Aktualisieren der E-Mail-Konfiguration für Kunden!"
    },
    slack: {
      checkboxLabel: "Slack Notifications",
      fieldLabel: "Notification-URL",
      fieldPlaceholder:
        "Notification-URL eingeben (diese Information bekommst du von Slack).",
      toastError: "Fehler im slack integration"
    },
    reclaimMode: {
      heading: "Gefilterter Lead-Modus",
      checkboxLabel: "Aktiviere den gefilterten Lead-Modus"
    },
    contactCloud: {
      connectBtn: "Verbinden",
      contactCloudSetup: "Contact Cloud Einrichtung",
      optionsError: {
        users: "benutzeroptionen",
        products: "produktoptionen",
        jobs: "job optionen"
      }
    },
    leadpool: {
      heading: "Leadpool"
    },
    appointment: {
      heading: "Kundentermin",
      label: "Treffen verknüpfung",
      placeholder: "Kalenderlink einfügen",
      confirm: "Terminbestätigung",
      type: "Terminart",
      onsite: "Vor Ort",
      phone: "Telefon",
      yes: "Ja",
      no: "Nein",
      recipients: "Empfänger Terminbestätigung",
      recipient: "Empfänger Terminbestätigung {{number}}",
      optional: "(optional)",
      recipientPlaceholder: "name@firma.de",
      recipientsHint:
        "Erhalten Terminbestätigung, Terminabsage, Terminverschiebung und die E-Mail „Lead nicht erreicht“. Die Benachrichtigung über neue Leads wird separat im Bereich „Email“ eingestellt.",
      recipientsFallback:
        "Noch nicht hinterlegt: geht an alle Adressen im Bereich „Email“"
    },
    advertisingAccount: {
      heading: "Werbekonto",
      label: "Werbekonto Verknüpfung",
      placeholder: "Eingeben werbekonto verknüpfung"
    }
  },
  modalContent: {
    saveAsTemplate: "Als{{new}}Vorlage speichern",
    deleteOutcome: `Bist Du Dir sicher, dass Du dieses Ergebnis <span class="text-danger">löschen</span> möchten? 
    <div> Weil es als Antwortaktion in <span class="text-danger fw-bold">funnel QA</span> </div>`,
    deleteFunnel: `Sind Sie sicher, dass Sie diese Frage <span class="text-danger">löschen</span> möchten?`,
    responseAction: "Weil es als Antwortaktion in",
    funnel: {
      unsavedWarning:
        "Sie haben ungespeicherte Änderungen. Speichern Sie diese, um als Vorlage zu speichern",
      unarchiveFunnelTitle: "Funnel aus dem Archiv entfernen",
      unarchiveFunnelMsg: `Möchten Sie diesen Funnel <span class="fw-bold">aus dem Archiv entfernen?</span>`,
      note: "Dieser Funnel hat keine Domain & Subdomain!",
      discardUnsavedWarning: `Ihre ungespeicherten Funnels werden <strong>verworfen</strong>. Möchten Sie fortfahren?`
    }
  },
  adCopy: {
    title: "Anzeigentext",
    noAdMessage: "Keine Anzeige extrahiert",
    dataCompleted: "Trainingsdaten vervollständigt",
    emojis: "Emojis",
    funnelURL: "Funnel-URL"
  },
  adDuplicator: {
    fetchAdAcc: "Anzeigenkonten abrufen",
    fetchAd: "Anzeige abrufen",
    pasteAndFetchAd: "Anzeige einfügen und abrufen",
    uploadAdsToFb: "Laden Sie Anzeigen auf Facebook hoch",
    clearAllAds: "Alles löschen",
    title: "Anzeigenduplizierer",
    viewIdLabel: "Anzeigen-ID",
    imgStatus: "Bildstatus",
    adStatus: "Anzeigenstatus",
    disabledDropImageMsg: "Überprüfen Sie die hochzuladende Anzeige",
    adUploadingStatus: {
      waiting: {
        status: "BEREIT ZUM ERSTELLEN",
        message: "Ich warte darauf, eine Facebook-Anzeige zu erstellen."
      },
      uploading: {
        status: "HOCHLADEN...",
        message: "Anzeige auf Facebook erstellen."
      },
      success: { status: "ERFOLG", message: "Anzeige erfolgreich erstellt." },
      rejected: { status: "ABGELEHNT" }
    }
  },
  basics: "Grundlegendes",
  leadSyncMsg:
    "Lead ist bereits synchronisiert. Möchtest Du erneut <strong>synchronisieren</strong>?",
  passwordChangeMsg: "Passwort erfolgreich geändert!",
  overview: "Übersicht",
  infoDetails: "Info-Details",
  hubspotID: "Hubspot ID",
  hubspotProjectID: "Hubspot Projekt ID",
  contactCloudID: "Contact Cloud ID",
  createNewFunnel: "Neuen Funnel erstellen",
  updateTemplate: "Aktualisieren Vorlage",
  createTemplate: "Neue Vorlage erstellen",
  createFunnelFromTemplate: "Erstelle einen neuen Funnel aus dieser Vorlage",
  dropImageMsg: "ZIEHE EIN BILD HIERHER ODER LADE EINS HOCH",
  dropPdfMsg: "ZIEHE EIN PDF HIERHER ODER LADE EINS HOCH",
  noIntegrationMsg: "Keine Integration gefunden!",
  noAssetMsg: "Kein Asset gefunden",
  noResults: "Keine Ergebnisse",
  overlayMsg: "Wird geladen",
  duplicateLoaderMessage: "Funnel duplizieren...",
  leadServiceError: "Fehler beim Aktualisieren des Funnel-Leadservices!",
  clipBoardNotAllowedMessage:
    "Bitte erlauben Sie die Berechtigung für die Zwischenablage",
  delete: "Löschen",
  notificationURLPlaceholder:
    "Notification-URL eingeben (diese Information bekommst du von Zapier).",
  or: "oder",
  title: "Titel",
  addDomainModal: {
    title: "Add domain and subdomain",
    btnText: "Save and remove from archive"
  },
  viewGalleryModal: {
    title: "Bild auswählen",
    addImage: "Neues Bild hinzufügen"
  },
  download: "Herunterladen",
  createNewCity: "Neuen Stadt erstellen",
  createNewCustomer: "Neuen Kunde erstellen",
  moveToCustomers: "Verschieben zu Kunden",
  moveToCustomerDialog: {
    title: "Wechseln Sie zu Kunden",
    para: "Möchten Sie dies an Kunden weitergeben?",
    saving: "Sparen...",
    btn: "Ja"
  },
  customerStats: {
    leads: "Führt",
    budget: "Budget",
    conversionRate: "Konvertierungsrate"
  },
  createNewCategory: "Neuen Kategorie erstellen",
  createFunnelModal: {
    title: "Welche Art {{type}} möchtest du erstellen?",
    actions: {
      lead: "Neukunden",
      employee: "Mitarbeiter"
    }
  },
  createIntegrationTitle: "Integration für diesen Funnel anlegen",
  duplicateFunnelTitle: "Duplikation bestätigen",
  duplicateFunnelMessage:
    "Möchten Sie diesen Funnel <strong>duplizieren</strong>?",
  duplicateFunnelMessageForFB:
    "Möchten Sie diesen Funnel ohne Facebook-Formulardetails <strong>duplizieren</strong>?",
  archiveLeadMessage: `Möchtest du den Lead wirklich <strong class = "text-lowercase" >{{archive}}</strong>`,
  archiveFunnelMessage:
    "Möchtest du den Funnel wirklich <strong>archivieren</strong>? Die öffentliche Seite des Funnels ist danach nicht mehr erreichbar.",
  deleteTemplateMessage: `Sind Sie sicher, dass Sie diese Vorlage <strong class="text-danger">löschen</strong> möchten?`,
  deleteImageMessage: `Sind Sie sicher, dass Sie diese Bild <strong class="text-danger">löschen</strong> möchten?`,
  deleteCategoryMessage: `Sind Sie sicher, dass Sie diese Bild <strong class="text-danger">löschen</strong> dieser Kategorie?`,
  deleteKeywordMessage: `Sind Sie sicher, dass Sie diese Bild <strong class="text-danger">löschen</strong> dieser Keyword?`,
  // deleteUserTokenMessage: `Sind Sie sicher, dass Sie diese Bild <strong class="text-danger" >löschen</strong>  dieser Benutzertoken?`, // Translated by google
  deleteCategorySuccess: "Kategorie erfolgreich gelöscht.",
  deleteKeywordSuccess: "Keyword erfolgreich gelöscht.",
  // deleteUserTokenSuccess: "Benutzertoken erfolgreich gelöscht.", // Translated by google
  clearAdDuplicatorFilesTitle: "Fahren Sie mit der neuen Anzeigen-ID fort",
  clearAdDuplicatorFiles:
    "Sie haben einige ausstehende Anzeigen mit der alten Anzeigen-ID. Verwerfen Sie ausstehende Anzeigen und fahren Sie mit der neuen Anzeigen-ID fort?",
  modern: {
    selectFunnelDesign: "Funnel-Design auswählen",
    backgroundColorAbove: "Hintergrund-Farbe oben",
    backgroundColorBelow: "Hintergrund-Farbe unten",
    headerLabelColor: "Telefon und Email Button",
    contrastColor: "Hintergrundfarbe der Fragen",
    taglineColor: "Rechte Spalte Oben Schriftfarbe",
    taglineBackground: "Rechte Spalte Oben Hintergrundfarbe",
    callLabel: "Angezeigte Nummer",
    telephoneNumber: "Welche Telefonnummer soll angerufen werden?",
    emailAddress: "E-Mail Adresse",
    headline: "Ganz oben Funnel Überschrift",
    taglineOne: "Rechte Spalte Oben Überschrift",
    taglineTwo: "Rechte Spalte Oben Subtitel",
    formHeading: "Überschrift über Name & Email",
    infoLabelOne: "Linke Spalte Headline Eintragungsformular",
    infoLabelTwo: "Linke Spalte Subtitel Eintragungsformular",
    infoLabelThree: "Linke Spalte Hinweis zum  Eintragungsformular",
    uspLabel: "USP (Vorteile / Benefits)",
    addNewUspLabel: "USP hinzufügen",
    colorLabel: "Farbe",
    iconLabel: "Icon",
    label: "Beschriftung",
    callToActionButtonHeading: "Call-to-Action-Schaltfläche",
    uspLabelPlaceholder: "USP-Label hinzufügen",
    deleteUspMessage: `Sind Sie sicher, dass Sie diese USP <strong class="text-danger">löschen</strong> möchten?`,
    deleteUspSuccess: "USP erfolgreich gelöscht",
    nextButton: {
      heading: "Weiter Button",
      btnTextColor: "Text-Farbe",
      btnBackgroundColor: "Hintergrund-Farbe",
      btnHoverBackground: "Hover Hintergrund-Farbe"
    }
  },
  createFunnel: "Funnel erstellen",
  createUser: "Benutzer erstellen",
  duplicateAnswer: "Antwort duplizieren",
  deleteAnswer: "Antwort löschen",
  duplicateQuestion: "Frage duplizieren",
  copyQuestion: "Frage kopieren",
  duplicatedQuestion: "Doppelte Frage",
  pasteQuestion: "Frage einfügen",
  pasteQuestionSuccess: "Frage erfolgreich eingefügt",
  pasteQuestionError: "Frage-ID nicht erkannt",
  clipboardCopySuccess: "{{what}} wurde in die Zwischenablage kopiert",
  deleteQuestion: "Frage löschen",
  question_one: "Frage",
  question_other: "Fragen",
  endQuestionnaire: "Fragebogen beenden",
  jumpToNextQuestion: "Zur nächsten Frage springen",
  jumptToQuestion: "Springe zu Frage",
  jumptToOutcome: "Zur Outcome # {{num}} springen",
  addNewQuestion: "Neue Frage hinzufügen",
  addNewOutcome: "Neues Outcome hinzufügen",
  addIcon: "Symbol hinzufügen",
  changeIcon: "Symbol ändern",
  layout: "Gestaltung",
  searchImage: "Durchsuchen",
  backgroundImage: "Hintergrundbild",
  companyLogo: "Firmenlogo",
  companyLogoBG: "Hintergrund des Firmenlogos",
  baseColor: "Grundfarbe",
  footerTxtColor: "Textfarbe des Fußbereichs",
  footerColors: {
    black: "Schwarz",
    white: "Weiß",
    whiteShadow: "Weiß (Schatten)"
  },
  companyLogoScale: "Skalierung des Firmenlogos",
  partnerLogoSection: {
    autoLight: "Automatisch – Hell",
    autoDark: "Automatisch – Schwarz",
    manual: "Eigenes Bild",
    scale: "Logo-Größe im Partnerlogo (%)",
    missingCompanyLogo: "Bitte zuerst ein Firmenlogo hinterlegen"
  },
  textElements: "Text-Elemente",
  nextButtonText: `Text des "Weiter" Buttons`,
  nextButtonBG: `Hintergrund des "Weiter" Buttons`,
  waitingScreen: "Warte-Screen",
  zipCodeScreen: "Postleitzahl-Screen",
  formScreen: "Formular-Screen",
  fieldTitle: "Feldtitle",
  fieldPlaceholder: "Feld-Placeholder",
  firstAndLastName: "Vor- & Nachname",
  forQuestions: "für eventuelle Rückfragen",
  submitButton: "Absenden-Button",
  getAnOffer: "Jetzt Angebot erhalten",
  freeOfCharge: "kostenlos & unverbindlich",
  numberCheck: "Nummernprüfung",
  phoneNumberVerification: "Telefonnummer Überprüfung",
  thankyouPage: "Danke-Seite",
  textOnThankyouPage: "Text auf",
  websiteBtnForThankyouPage: "Button zur Webseite auf Dankeseite",
  greetingPhrase: "Grußsatz",
  redirect: {
    switchLabel: "Leite Lead um",
    fieldLabel: "Leite URL um",
    fieldPlaceholder: "Gib die Umleitungs-URL ein"
  },
  emailEdit: {
    email: "Termin-E-Mail",
    confirm: "Terminbestätigung E-Mail",
    cancel: "Terminabsage E-Mail",
    postpone: "Terminverschiebung E-Mail",
    notReached: "Lead Nicht Erreicht E-Mail",
    noContent: "Kein Inhalt",
    subjectPlaceholder: "E-Mail-Betreff",
    noSubject: "Kein Betreff",
    subject: "Betreff",
    placeholder: "Platzhalter Einfügen",
    leadName: "Lead Name",
    leadEmail: "Lead E-Mail",
    appointmentDate: "Termin Datum",
    appointmentTime: "Termin Uhrzeit"
  },
  cancelEditing: "Bearbeitung abbrechen",
  link: "Verknüpfen",
  addNewCondition: "Neue Bedingung hinzufügen",
  addNewGroup: "Neue Gruppe hinzufügen",
  enterHeading: "Überschrift eingeben",
  msgPlaceholder:
    "Schreiben Sie eine Nachricht, die angezeigt wird, wenn der Benutzer nicht den oben genannten Kriterien entspricht.",
  customerName: "Kundenname",
  customerInfo: "Kundeninformationen",
  summary: "Zusammenfassung",
  budget90DaysLabel: "Bugdet der letzten 90 Tage",
  viewMore: "Mehr anzeigen",
  view: "Anzeigen",
  viewHere: "Hier ansehen",
  categoryDescription: "Kategoriebeschreibung",
  leadPriceBenchmark: "Leadpreis Benchmark",
  leadQualifiedPriceBenchmark: "Qualifizierter Leadpreis Benchmark",
  leadPriceCurrentText: "Facebook Leadpreis (14 Tage)",
  leadQualifiedPriceCurrentText: "Qualifizierter Leadpreis (14 Tage)",
  enterCategoryDesc: "Kategoriebeschreibung eingeben",
  categoryForm: "Kategorieformular",
  missingToken: "Token fehlt!",
  domainArchivedMsg1:
    "Diese Domain und Subdomain wird bereits in einem archivierten Funnel verwendet!",
  domainArchivedMsg2: "Diese Domain und Subdomain wird bereits verwendet!",
  domainAlreadyTakenMsg: `Diese <span class="fw-bold">Domain und Subdomain</span> ist bereits vergeben, möchtest Du fortfahren?`,
  useAnyway: "Trotzdem verwenden",
  notAllowedDomainMsg: "Du kannst diese Domain und Subdomain nicht verwenden",
  endDateWarning: "Enddatum sollte größer als Startdatum sein...",
  minmaxRangeWarning:
    "Der Mindestwert sollte kleiner sein als der Höchstwert...", // Translated by google
  wrongDate: "Falsches Datum...",
  backToLogin: "Zurück zur Anmeldung",
  loginSuccessFull: "Sie haben sich erfolgreich angemeldet!",
  resetPassword: "Passwort zurücksetzen",
  generatePassword: "Passwort generieren",
  password: "Passwort",
  newPassword: "Neues Passwort",
  confirmNewPassword: "Neues Passwort bestätigen",
  reset: "Zurücksetzen",
  assetUpdateMsg: "Asset erfolgreich aktualisiert!",
  uploadedOn: "Hochgeladen am",
  uploadImage: "Bild hochladen",
  fileType: "Dateityp",
  job: "Stélle",
  tonality: "Tonalität",
  speech: "Ansprache",
  specialInstructions: "Spezielle Anweisungen",
  open: "Öffnen",
  views: "Aufrufe",
  contact: "Kontakte",
  completionRate: "Abschlussquote",
  conversionRate: "Konvertierungsrate",
  noData: "Keine Daten zum Anzeigen",
  customerForm: "Kundenformular",
  customerNumber: "Kundennummer",
  enableAIInterviewAndDossier: "AI-Interview und Dossier aktivieren",
  contactDetails: "Kontaktdetails",
  selectFbPage: "Facebook-Seite auswählen",
  selectUserAccount: "Benutzerkonto auswählen",
  selectFbForm: "Facebook-Formular auswählen",
  formQuestions: "Formularfragen",
  userDetails: "Benutzerdetails",
  pageDetails: "Seitendetails",
  formDetails: "Formulardetails",
  getPages: "Seiten abrufen",
  retrievePagesNote:
    "Keine Optionen verfügbar! Bitte holen Sie zuerst Seiten, um Auswahlmöglichkeiten zu aktivieren.",
  tonalities: {
    Seriös: {
      title: "Seriös",
      description:
        "Verwendet für Finanzdienstleistungen, Anwaltskanzleien, medizinische Produkte und Dienstleistungen. Der Schwerpunkt liegt auf Vertrauen und Professionalität."
    },
    Lässig: {
      title: "Lässig",
      description:
        "Geeignet für Lifestyle-Produkte, Freizeitbekleidung oder Apps für junge Erwachsene. Es vermittelt ein Gefühl von Entspanntheit und Unkompliziertheit."
    },
    Humorvoll: {
      title: "Humorvoll",
      description:
        "Ein humorvoller Ton kann verwendet werden, um die Aufmerksamkeit der Zielgruppe zu gewinnen, etwa bei Snack-Produkten, Spielen oder Werbung für Filme."
    },
    Inspirierend: {
      title: "Inspirierend",
      description:
        "Oft verwendet für Sportbekleidung, Reisewerbung oder gemeinnützige Organisationen. Es soll den Betrachter motivieren und ein Gefühl der Bewunderung oder des Strebens vermitteln."
    },
    Romantisch: {
      title: "Romantisch",
      description:
        "Geeignet für Produkte wie Parfüm, Schmuck oder Reisen zu romantischen Zielen. Es erzeugt Gefühle von Intimität und Leidenschaft."
    },
    Sachlich: {
      title: "Sachlich",
      description:
        "Dieser Ton ist direkt und ohne Schnörkel. Er könnte für technische Produkte, Handwerksdienstleistungen oder Bildungsangebote geeignet sein."
    },
    Nostalgisch: {
      title: "Nostalgisch",
      description:
        "Dies kann verwendet werden, um ein Gefühl der Sehnsucht oder Erinnerung zu erzeugen, vielleicht für Retro-Produkte oder Marken mit einer langen Geschichte."
    },
    Provokativ: {
      title: "Provokativ",
      description:
        "Einige Marken wählen eine herausfordernde oder kontroverse Tonalität, um Aufmerksamkeit zu erregen und Diskussionen zu provozieren."
    },
    Luxuriös: {
      title: "Luxuriös",
      description:
        "Für High-End-Produkte wie Designerkleidung, Luxusautos oder erstklassige Reisedienste. Die Werbung betont Exklusivität und Raffinesse."
    },
    Pädagogisch: {
      title: "Pädagogisch",
      description:
        "Informiert den Betrachter und vermittelt Wissen. Dies könnte für Bücher, Bildungssoftware oder wissenschaftliche Produkte geeignet sein."
    }
  },
  notSynced: "Noch nicht synchronisiert!",
  customAnswerMsg:
    "Für diese <strong>Art</strong> von Frage sind keine Antworten erforderlich.",
  campaign: "Kampagne",
  facebookPgID: "Facebook-Seiten-ID eingeben",
  questionnaire: "Fragebogen",
  phoneServiceQuestionnaire: "Telefonische Fragen (Leadservice)",
  leadIdLabel: "Lead-ID",
  googleAdsLead: {
    title: "Google Ads",
    id: "ID",
    campaign: "Kampagne",
    adgroup: "Anzeigengruppe",
    keyword: "Keyword",
    matchtype: "Match-Typ",
    device: "Gerät",
    network: "Netzwerk",
    landingPage: "Landingpage",
    gclid: "Google Click ID"
  },
  currentVersion: "Aktuelle Version",
  activatePrimaryMessage: `Sind Sie sicher, dass Sie dieses Benutzertoken <span class="fw-bold">aktivieren</span> möchten?`, // Translated by google
  connectFbMessage: `Sind Sie sicher, dass Sie sich mit Facebook <span class="fw-bold">erneut validieren</span> möchten?`, // Translated by google
  openProject: "Projekt öffnen",
  openAdvertisingAccount: "Werbekonto öffnen",
  openInTest: "Im Test-Modus öffnen",
  script: "Skript",
  leadService: "Leitender Service",
  filteredLead: "Gefilterter Lead",
  appointmentConfirm: "Terminbestätigung",
  offerFollowup: "Angebotsnachverfolgung",
  funnelQA: {
    textOnly: "Nur Text",
    freeText: "Freitextfeld",
    slider: "Schieberegler",
    multi: "Mehrfach ausgewählt",
    single: "Einzeln ausgewählt",
    selectOption: "Eine Option auswählen",
    questionPlaceholder: "Frage hier hinzufügen"
  },
  funnelInsights: {
    leadService: {
      total: "Gesamte Anfragen",
      open: "Offene Anfragen",
      nameWrong: "Falscher Name",
      numberWrong: "Falsche Nummer",
      notReached: "Nicht erreicht Anfragen",
      // notSuitable: "Nicht geeignete Anfragen",
      notSuitableDueToCallResult: "Nicht geeignet durch Anrufergebnis",
      notSuitableDueToAccessibility: "Nicht geeignet durch Erreichbarkeit",
      suitable: "Geeignete Anfragen"
    },
    allLandingVisits: "Alle Funnelbesucher",
    visits: "Anzahl der Besucher je Gerät",
    websiteVisits: "Webseitenbesucher",
    phoneVisits: "Anrufversuch Klicks",
    emailVisits: "E-Mail Button Klicks",
    adEval: { totalBudget: "Ausgegebenes Budget für diesen Zeitraum" },
    interview: {
      title: "KI-Interview (nach Eintragung)",
      versionIndependent: "versionsunabhängig",
      sinceActivation: "seit Aktivierung am {{date}}",
      leadsTotal: "Leads erstellt",
      shown: "Interview angezeigt",
      stepShort: "F",
      completed: "Abgeschlossen",
      startRate: "Startquote",
      startRateSub: "mind. eine Frage beantwortet",
      completionRate: "Abschlussquote",
      completionRateSub: "der angezeigten Interviews",
      avgAnswered: "Ø beantwortete Fragen",
      avgPlanned: "von Ø geplant",
      voiceShare: "Anteil Spracheingabe",
      chips: "Chips",
      text: "Text",
      skippedImmediately: "Sofort übersprungen",
      skippedPartial: "Nach Antworten übersprungen",
      abandoned: "Verlassen"
    }
  },
  appointmentNote: {
    book: "Termin vereinbart am: ",
    confirm: "Termin bestätigt - ",
    cancel: "Termin abgesagt",
    postpone: "Termin verschoben - neuer Termin: "
  },
  sync: "Synchronisieren",
  forwardedOnContactCloud: "Weitergeleitet an Contact Cloud",
  forwardedTooltips: {
    success: "Der Lead wurde an den Kunden weitergeleitet",
    pending: "Der Lead befindet sich aktuell noch im Telefonservice",
    failed: "Der Lead ist entweder nicht geeignet oder wurde nicht erreicht",
    aiLeadservice:
      "Der Lead wird aktuell vom KI-Leadservice telefonisch vorqualifiziert",
    inVerificationProcess:
      "Der Lead befindet sich aktuell in der digitaler Verifizierung",
    inInterviewWithAI: "Der Lead befindet sich aktuell in einem KI-Interview"
  },
  multifactor: {
    emailAuth: "E-Mail-Authentifikator",
    appAuth: "App-Authentifikator",
    scan: {
      heading: "Scannen"
    },
    verify: {
      heading: "Code Verifizieren",
      msg: "Um die Einstellung zu ändern, bitte den Authentifizierungscode verifizieren:"
    },
    configure: {
      heading: "Einrichtung von Google Authenticator oder Authy",
      step1:
        "Installiere Google Authenticator (IOS - Android) oder Authy (IOS - Android).",
      step2: `Wähle im Authenticator-App das " + " Symbol.`,
      step3: `Wähle "Einen Barcode (oder QR-Code) scannen" und benutze die Kamera des Handys, um diesen Barcode zu scannen.`
    },
    title: "Mehrfaktorauthentifizierung (MFA)",
    subtitle: "Sichere dein Konto mit TOTP-Zwei-Faktor-Authentifizierung",
    setup: "Einrichtung",
    btnText: "Verifizieren & Aktivieren",
    disableHeading: "Zwei-Faktor-Authentifizierung (2FA) deaktivieren",
    method: "Authenticator-Methode",
    sendCode: "Code senden",
    sendCodeMsg: "Einen Verifizierungscode senden an",
    verificationMsg: `Verifizierungscode wurde gesendet! Wenn du den Code nicht erhalten hast, versuche es in <strong>{{timer}}</strong> Sekunden erneut.`
  },
  common: {
    select: "Auswählen",
    selected: "Ausgewählte",
    font: "Schrift",
    problem: "Problem",
    ignore: "Ignorieren", // Translated by google
    creative: "Kreatives", // Translated by google
    understood: "Verstanden",
    benchmark: "Benchmarck",
    difference: "Difference",
    action: "Action",
    security: "Sicherheit",
    generate: "Erstellen",
    addNew: "Neu hinzufügen",
    user: "Benutzer",
    user_other: "Benutzer",
    logic: "Logik",
    headline: "Überschrift",
    product: "Produkt",
    job: "Stelle",
    enter: "Eingeben",
    import: "Importieren",
    template: "Vorlage",
    template_other: "Vorlagen",
    message: "Nachricht",
    heading: "Heading",
    lead: "Lead",
    lead_other: "Leads",
    funnel: "Funnel",
    funnel_other: "Funnels",
    name: "Name",
    email: "Email",
    syncStatus: "Synchronisierungsstatus",
    update: "Aktualisieren",
    confirmDeletion: "Löschen bestätigen",
    yes: "Ja",
    no: "Nein",
    selectColor: "Farbe auswählen",
    create: "Erstellen",
    source: "Quelle",
    leadSource: "Lead Quelle",
    role: "Rolle",
    firstName: "Vorname",
    lastName: "Nachname",
    city: "Stadt",
    country: "Land",
    new: "Neues",
    old: "Altes",
    changePassword: "Passwort ändern",
    enterEmail: "Email eingeben",
    forgotPassword: "Passwort vergessen",
    send: "Senden",
    login: "Anmelden",
    logout: "Ausloggen",
    alreadyTaken: "Bereits vergeben",
    isAlreadyTaken: "ist bereits vergeben",
    categories: "Kategoriename",
    back: "Zurück",
    save: "Speichern",
    templateName: "Vorlagenname",
    postalCode: "Postleitzahl",
    blockedOn: "Blockiert am",
    search: "Suche",
    type: "Typ",
    of: "von",
    results: "Ergebnissen werden angezeigt",
    result: "Ergebnis",
    archive: "Archiv",
    unarchive: "Unacrvhiv",
    customer: "Kunde",
    activeCampaignsOnly: "Nur aktive Kampagnen",
    displayFunnelsWithFbLeadsOnly: "Funnel nur mit Fb-Leads anzeigen",
    customer_other: "Kunden",
    address: "Adresse",
    category: "Kategorie",
    category_other: "Kategorien",
    form: "Formular",
    answer: "Antwort",
    companyInfo: "Unternehmens-Informationen",
    companyName: "Firmenname",
    companyWebsite: "Firmen Webseite",
    website: "Webseite",
    websiteBtnTxt: "Text für Website-Button",
    dataProtection: "Datenschutz",
    imprint: "Impressum",
    createCustom: "Benutzerdefiniert erstellen",
    telephone: "Telefon",
    preview: "Vorschau",
    saveFunnel: "Speichern Funnel",
    cancel: "Abbrechen",
    description: "Beschreibung",
    close: "Schließen",
    edit: "Bearbeiten",
    created: "Erstellt",
    appointmentOn: "Termin am: ",
    to: "auf",
    on: "am",
    postponedNote: "Termin Verschoben - Neuer Termin: ",
    from: "von",
    company: "Firma",
    createNew: {
      title: "Neuen {{name}} zuordnen"
    },
    // assignNew: {
    //   title: "Neuen {{name}}"
    // },
    enable: "Aktivieren",
    enabled: "Aktiviert",
    openInNewTab: "In neuem tab öffnen",
    sortBy: "Sortieren nach",
    sortOrder: "Reihenfolge sortieren",
    performanceReport: "Leistungsbericht",
    invoices: "Rechnungen",
    deleted: "GELÖSCHT",
    change: "Ändern",
    confirm: "Bestätigen",
    appointmentDetail: "Datum und Uhrzeit des Termins",
    charactersCount: "Anzahl der Zeichen",
    inactive: "Inaktiv",
    blockedCount: "Anzahl blockierter Postleitzahlen",
    reportType: "Berichtstyp",
    requestTime: "Anfragezeit",
    errorMsg: "Fehlermeldung",
    keyword: "Keyword",
    keywords: "Keywords",
    keywordImageSizeRecommendation:
      "Bilder sollten im Format 1200 × 900 Pixel hochgeladen werden",
    refresh: "Aktualisieren",
    invalidPriceValue: "Bitte gib einen gültigen Wert ein."
  },
  monthsName: {
    jan: "Januar",
    feb: "Februar",
    mar: "März",
    apr: "April",
    may: "Mai",
    jun: "Juni",
    jul: "Juli",
    aug: "August",
    sep: "September",
    oct: "Oktober",
    nov: "November",
    dec: "Dezember"
  },
  missingInfo: {
    leadCount: "Lead-Anzahl",
    funnel: {
      selectCategory: "Kategorie wählen", // Translated by google
      selectCustomer: "Wählen Sie Kunde" // Translated by google
    },
    lead: {
      selectFunnel: "Wählen Sie Trichter" // Translated by google
    }
  },
  advancedFilter: {
    title: "Erweiterte Filter",
    formType: "Formulartyp",
    search: "Suchen",
    archive: "Beinhaltet Archiv",
    userStatus: "Benutzerstatus",
    tags: "Tags",
    status: "Status",
    leadStatus: "Lead Status",
    funnel: "Funnel",
    priceRange: "Ausgegebenes Budget",
    dateRange: {
      today: "Heute",
      yesterday: "Gestern",
      thisWeek: "Diese Woche",
      lastWeek: "Letzte Woche",
      thisMonth: "Dieser Monat",
      lastMonth: "Letzter Monat",
      thisYear: "Dieses Jahr",
      lastYear: "Letztes Jahr",
      last7D: "Letzte 7 Tage",
      last14D: "Letzte 14 Tage",
      last30D: "Letzte 30 Tage",
      last90D: "Letzte 90 Tage",
      custom: "Benutzerdefiniertes Datum",
      days7: "7 Tage",
      days14: "14 Tage",
      days30: "30 Tage",
      days90: "90 Tage",
      customRangeUptoNinetyDays: "Range"
    },
    fbSort: {
      leadCount: "Lead-Anzahl",
      costPerLead: "Kosten pro Lead",
      click: "Anzahl Klicks",
      reach: "Reichweite",
      impreesions: "Impressionen",
      costPerClick: "Kosten pro Klick",
      spend: "Budget",
      costPerQualified: "Kosten pro qualifiziertem Lead", // Translated by google
      qualifiedCount: "Anzahl qualifizierter Leads", // Translated by google
      leadQualify: "LeadQualität", // Translated by google
      leadCost: "Leadkosten", // Translated by google,
      conversionRate: "Konvertierungsrate"
    },
    sortOrder: {
      highestFirst: "Höchster zuerst", // Translated by google
      lowestFirst: "Niedrigste zuerst" // Translated by google
    },
    funnelType: "Funnel Typ"
  },
  sidebar: {
    dashboard: "Dashboard",
    templates: "Vorlagen",
    funnelTemplates: "Trichtervorlagen",
    globalThankYouTemplate: "Globale Dankesseiten",
    customers: "Kunden",
    categories: "Kategorien",
    gallery: "Gallery",
    tags: "Tags",
    users: "Benutzer",
    settings: "Einstellungen",
    siteSettings: "Seiteneinstellungen", // Translated by google
    profile: "Profil",
    leadAgent: "Lead Agent",
    appointmentConfirm: "Terminbestätigung",
    advertisements: "Werbeanzeigen",
    adOptimization: "Optimierungen",
    blockPostalCode: "Blockiert Postleitzahl",
    websiteLogs: "Website Logs",
    splitTests: "Split-Tests",
    fulfillmentKpis: "Fulfillment-Kennzahlen"
  },
  funnelTable: {
    all: "Alle",
    leadCount: "Lead Anzahl",
    lastChange: "Letzte Bearbeitung",
    integrationStatus: "Integrationsstatus"
  },
  templateTable: {
    lastModified: "Zuletzt geändert"
  },
  userSearchPlaceholder: "Suche nach Name oder E-Mail",
  searchByNamePlaceholder: "Suche nach Name",
  searchByEmailPlaceholder: "Suche nach E-Mail",
  leadAgent: {
    autopilot: {
      title: "Autopilot",
      reason: {
        silent: "Keine Antwort auf WhatsApp seit 2 Tagen",
        never_answered: "Nie auf WhatsApp geantwortet",
        undeliverable: "WhatsApp nicht zustellbar",
        landline: "Festnetznummer, kein WhatsApp",
        invalid: "Nummer für WhatsApp ungültig",
        opted_out_whatsapp: "Von WhatsApp abgemeldet",
        whatsapp_paused: "WhatsApp-Gespräch pausiert",
        reactivation: "Reaktivierte Altanfrage",
        callback_requested: "Rückruf gewünscht",
        later: "Zurück beim Autopilot (später)",
        team: "Vom Team an den Lead Service übergeben",
        clarify: "Klärung nötig"
      },
      ended: "Autopilot abgeschaltet – Stand aus dem Chat",
      nothingClarified: "Im Chat noch nichts geklärt",
      // am_autopilot lib/reactivation.js OUTCOMES
      reactivationOutcome: {
        current: "Noch aktuell",
        questions: "Fragen zum Angebot",
        considering: "Braucht noch Zeit",
        second_look: "Will doch sprechen",
        plan_ahead: "Plant schon jetzt",
        clarify: "Klärung nötig",
        no_answer: "Keine Antwort",
        undeliverable: "Nicht zustellbar"
      },
      answered: "Bereits beantwortet",
      open: "Noch offen",
      unsure: "Im Termin klären",
      source: {
        funnel: "Funnel",
        whatsapp: "WhatsApp",
        phone: "Telefon",
        earlier: "Frühere Anfrage"
      },
      chatSummary: "WhatsApp-Verlauf",
      photos: "Fotos geschickt",
      photosYes: "ja ({{count}})",
      photosNo: "nein",
      earlierAnswers: "Aus der früheren Anfrage",
      budget: "Budget",
      budgetTooLow: "zu niedrig, Lead nicht geeignet",
      book: "Termin buchen",
      callFirst: "Erst den Anruf starten.",
      freeSlots: "Freie Zeiten",
      type: { PHONE: "Telefon", ONSITE: "Vor Ort", SHOWROOM: "Ausstellung" },
      noSlots: "Keine freien Zeiten im Kalender des Betriebs.",
      address: {
        streetName: "Straße",
        buildingNumber: "Nr.",
        postalCode: "PLZ",
        city: "Ort"
      },
      email: "E-Mail des Kunden",
      showroom: "Termin in der Ausstellung: {{address}}",
      answerOpenFirst:
        "Offene Fragen beantworten oder für den Termin markieren.",
      confirmBooking: "Verbindlich buchen",
      booked:
        "Termin gebucht: {{when}}. Der Kunde bekommt die Bestätigung per WhatsApp oder SMS.",
      wishNoted: "Wunschtermin notiert: {{when}}. Der Betrieb bestätigt ihn.",
      bookingError: {
        SLOT_TAKEN:
          "Diese Zeit ist gerade vergeben worden. Bitte eine andere wählen.",
        BUDGET_TOO_LOW:
          "Budget zu niedrig – kein Termin. Bitte als „Nicht geeignet“ abschließen.",
        ADDRESS_MISSING: "Die Adresse fehlt.",
        EMAIL_MISSING: "Der Kalender braucht die E-Mail des Kunden."
      },
      actionRunning:
        "Für diesen Lead läuft gerade noch eine andere Aktion. Bitte kurz warten.",
      unreachable: "Autopilot nicht erreichbar, bitte erneut versuchen",
      retry: "Erneut versuchen",
      laterHint: "Der Autopilot meldet sich an diesem Tag per WhatsApp."
    },
    interview: {
      heading: "KI-Interview (Hausbesitzer)",
      slots: {
        beschreibung: "Projektbeschreibung",
        umfang: "Umfang",
        zeitrahmen: "Zeitrahmen",
        kaufreife: "Entscheidungsstand",
        budget: "Budgetrahmen",
        erreichbarkeit: "Beste Erreichbarkeit"
      },
      details: "Weitere Details",
      showQa: "Komplettes Frage-Antwort-Protokoll anzeigen ({{count}})",
      hideQa: "Protokoll ausblenden"
    },
    loadMore: "Mehr laden",
    searchBy: "Nach suchen",
    companyLocation: "Standort des Unternehmens",
    distanceToCustomer: "Entfernung zum Kunden",
    calcDistance: "Entfernung berechnen",
    postalCodeMissingMsg: "Postleitzahl fehlt",
    callInProgress: "Anruf läuft",
    callContact: "Kontakt anrufen",
    calling: "Wird angerufen...",
    sending: "Sendet...",
    completing: "Wird abgeschlossen...",
    complete: "Abgeschlossen",
    wrongNum: "Nummer falsch",
    notReached: "Nicht erreicht",
    wrongName: "Name falsch",
    sendContactToCustomer: "Kontakt an Kunden senden",
    leadInfo: "Lead-Informationen",
    interestedParty: "Interessent",
    enterValue: "Wert eingeben",
    dateOfRegistration: "Registrierungsdatum",
    speedDial: "Kurzwahl",
    availableDaily: "Täglich verfügbar",
    enterComment: "Kommentar eingeben",
    qualified: "Qualifiziert",
    notSuitable: "Nicht geeignet",
    appointmentWitHtheCustomer: "Einen Termin mit dem Kunden vereinbaren",
    appointmentInCalendy: "Einen Termin in Calendy buchen",
    noLeads: "Kein Lead zum Anzeigen",
    already: "Bereits",
    successfullyQualified: "Erfolgreich qualifiziert.",
    notQualifiedYet: "Noch nicht qualifiziert.",
    available: "Verfügbar",
    after: "Nach",
    callAnyway: "Anruf trotzdem",
    interactingWithAnotherAgent: "Interaktion mit ",
    leadServicePlusWarning:
      "Achtung, dieser Lead muss mit dem Leadserice Plus Skript bearbeitet werden",
    notes: "NOTIZEN",
    notesPlaceholder: "Notiz oder Kommentar für den Kunden hinzufügen...",
    emailsToSendHeading: "Email wird gesendet an",
    alreadyTakenMsg: "Dieser Lead wurde von einem anderen Agenten übernommen!",
    allOpenLeadsContactedMsg:
      "Alle offenen Leads, die von Funnel <strong>{{funnelName}}</strong> kontaktiert",
    noAppointmentForFunnel:
      "Keine bevorstehenden Lead-Termine innerhalb von 24 Stunden für Funnel <strong>{{funnelName}}</strong>",
    mandatoryLeadServiceAnswersRequired:
      "Bitte beantworte alle verpflichtenden Lead-Service-Fragen, bevor du den Lead qualifizierst.",
    mandatoryLeadServiceAnswersTooltip:
      "Offene Fragen müssen zuerst beantwortet werden.",
    noLeadsYetTooltip: "Noch keine leads!",
    backToNormalBtn: "Zur normalen Ansicht zurückkehren",
    contactLater: "Lead später kontaktieren",
    contactLaterDialogHeading: "Wann soll dieser Lead kontaktiert werden?",
    contactLaterPastDateError:
      "Das ausgewählte Datum darf nicht in der Vergangenheit liegen.",
    cancelling: "Absagen...",
    cancelled: "Termin Absagen",
    confirming: "Bestätigend...",
    confirmed: "Termin Bestätigen",
    postponed: "Termin Verschoben",
    appointmentDialogHeading: "Datum und Uhrzeit des Termins",
    businessTimeLabel: "Uhrzeit in deutscher Zeit",
    businessTimeSummary: "{{weekday}}, {{dateTime}} Uhr, deutsche Zeit",
    businessTimeHint:
      "Dieser Rechner läuft nicht auf deutscher Zeit ({{zone}}). Die Uhrzeit bitte so eintragen, wie sie mit dem Interessenten vereinbart ist, in deutscher Zeit.",
    appointmentTimeInvalid:
      "Diese Uhrzeit gibt es an dem Tag nicht (Zeitumstellung). Bitte eine andere Uhrzeit wählen.",
    // noUpcomingAppointment:
    //   "Keine bevorstehenden Lead-Termine innerhalb von 24 Stunden",
    appointmentTaken: "Termin Vergeben",
    appointmentNotTaken: "Termin nicht angenommen",
    question: "FRAGE",
    answer: "Antwort",
    noConfirmation: "Nicht Zur Terminbestätigung",
    appointmentType: "Art des Termins",
    individualNoteWarning: "Dieser Lead hat Sondervereinbarungen",
    warningPopupTitle: "Warnung",
    saveAppointment: "Termin speichern",
    forwardWithoutAppointmnet: "Ohne Termin weiterleiten",
    postponedTill: "Seit 2 Stunden als nicht verfügbar markiert",
    aiLeadserviceClosedTitle: "An AI LeadService gesendet",
    aiLeadserviceClosedMessage:
      "Dieser Lead wird vom AI LeadService bearbeitet. Übernimm ihn, um die AI-Bearbeitung zu stoppen und manuelle Aktionen wieder freizuschalten.",
    aiLeadserviceClosedNext: "Zum nächsten Lead",
    aiLeadserviceClosedToast:
      "Dieser Lead wird bereits vom AI LeadService bearbeitet. Der nächste Lead wird geladen.",
    aiLeadserviceTakeover: "Lead übernehmen",
    aiLeadserviceTakingOver: "Wird übernommen...",
    aiLeadserviceTakeoverError:
      "Der AI LeadService konnte nicht gestoppt werden. Bitte erneut versuchen."
  },
  appointmentTypes: {
    onSiteAtLeadAddress: "Vor Ort beim Interessenten",
    onSiteAtCompanyAddress: "Vor Ort in der Ausstellung",
    phoneAppointment: "Telefontermin",
    required: "Bitte wähle eine dieser Optionen"
  },
  leadActivities: {
    title: "Aktivitäten",
    noActivityMsg: "Bisher keine Aktivitäten für diesen Lead!",
    noteTooltip: "Notiz",
    agentInfo: "Agenten-Info",
    // enums
    type: {
      CALL: "Anruf",
      SMS: "SMS",
      EMAIL: "Email",
      RESET: "Zurücksetzen",
      SYNC_MANUALLY: "Manuelle Synchronisierung",
      PARTIAL_SYNC_MANUALLY: "Manuelle Synchronisierung Teilweise",
      DIGITAL_VERIFICATION: "Digitale Verifizierung",
      APPOINTMENT: "Termin",
      LEAD_RESUBMISSION: "Erneute Anfrage",
      AI_LEADSERVICE_HANDOFF: "An AI LeadService übergeben",
      AI_LEADSERVICE_MANUAL_TAKEOVER: "Lead aus AI LeadService übernommen",
      MANUAL_LEAD_SERVICE_REMOVAL: "Manuelle Entfernung aus dem Lead-Service",
      AUTOPILOT: "Autopilot"
    },
    resultType: {
      NUMBER_WRONG: "Nummer falsch",
      NAME_WRONG: "Name falsch",
      COMPLETED: "Daten korrekt",
      CALL: "Anruf",
      CALL_NOT_INITIATED: "Anruf nicht gestartet",
      QUALIFIED: "Lead ist qualifiziert",
      NOT_SUITABLE: "Lead ist nicht geeignet",
      NOT_REACHED: "Nicht erreicht",
      RESET_SUCCESS: "Vom Administrator zurückgesetzt",
      SYNCED_MANUALLY: "Manuell synchronisiert",
      CONTACT_LATER: "Lead später kontaktieren",
      APPOINTMENT_CALL: "Terminbestätigungsanruf",
      APPOINTMENT_CANCELLED: "Der Termin wurde abgesagt",
      APPOINTMENT_CONFIRMED: "Der Termin wurde bestätigt",
      APPOINTMENT_POSTPONED: "Der Termin wurde verschoben",
      APPOINTMENT_NOT_REACHED: "Nicht erreicht",
      APPOINTMENT_NOT_HANDLED: "Lead termin nicht behandelt",
      DIGITALLY_VERIFIED: "Digital Verifiziert",
      DIGITAL_VERIFICATION_FALLBACK: "Fallback bei digitaler Verifizierung",
      AVAILABILITY_SUBMITTED: "Verfügbarkeit übermittelt",
      APPOINTMENT_UPDATED: "Termin aktualisiert",
      LEAD_RESUBMITTED: "Erneut eingereicht",
      AI_LEADSERVICE_HANDED_OVER: "Erster KI-Anruf steht noch aus",
      AI_LEADSERVICE_TAKEN_OVER: "Manuelle Übernahme abgeschlossen",
      LEAD_SERVICE_REMOVED: "Aus Lead-Service entfernt",
      AUTOPILOT_APPOINTMENT: "Termin an Contact Cloud übergeben",
      AUTOPILOT_CLOSED: "Ohne Termin beendet",
      AUTOPILOT_ENDED: "Autopilot abgeschaltet",
      AUTOPILOT_REACTIVATION: "Vom Autopilot reaktiviert"
    },
    callAttempt: {
      title: "Anrufversuch",
      appointmentTitle: "Terminbestätigungs-Anrufversuch",
      result: "Ergebnis",
      attempt: "Versuch",
      startedAt: "Gestartet am",
      completedAt: "Abgeschlossen am",
      duration: "Dauer",
      nextAttemptAt: "Nächster Versuch",
      reason: "Grund",
      minute: "Minute",
      minutes: "Minuten",
      seconds: "Sekunden"
    },
    notInitiatedReason: {
      LEAD_UNAVAILABLE: "Lead ist aktuell nicht verfügbar"
    },
    resubmissionDetails: {
      title: "Anfrage erneut eingereicht",
      item: "Eintrag {{index}}",
      question: "Frage",
      answer: "Antwort",
      fields: {
        optimalAvailability: "Verfügbarkeit",
        changedAnswers: "Geänderte Antworten"
      }
    },
    systemActivity: {
      title: "Systemaktivität",
      at: "Zeitpunkt",
      reason: {
        MAX_CONTACT_ATTEMPTS_REACHED:
          "Maximale Anzahl an Kontaktversuchen erreicht"
      }
    }
  },
  adEvaluation: {
    creativeOverview: "Kreativübersicht",
    leadCount: "Anzahl der Leads",
    leadCost: "Kosten pro Lead",
    budgetSpent: "Budget ausgegeben",
    qualified: "Qualifizierte Leads",
    suggestionGallery: "Vorschlagsgalerie",
    adLabel: "Anzeige",
    adsetLabel: "Anzeigengruppe",
    titlesLabel: "Überschrift",
    descriptionsLabel: "Beschreibung",
    bodiesLabel: "Werbetext",
    expandBtnLabel: "Öffnen"
  },
  funnelsEvaluation: "Kundenbewertung",
  creativeDashboard: "Kreatives Dashboard", // Translated by google
  funnelDetailsOverview: "Übersicht über die Kundendetails",
  invalidIdErrorMessage: "Ungültige ID",
  sendBackToAgentTitle: "Diesen Lead an den Lead Agent zurücksenden",
  sendBackToAgentMessage: `Möchten Sie diesen Lead wirklich zurück zum <strong>Lead agent</strong> verschieben?`,
  tools: "Werkzeuge",
  linkedFunnels: "Verknüpfte Funnels",
  pricePerInvoiceUnitLabel: "Preis pro Rechnungseinheit",
  unitLabel: "Einheit",
  preventReloadWarning:
    "Website verlassen? Deine Änderungen wurden nicht gespeichert!",
  downloadAsCsv: "Herunterladen als CSV",
  suggestionGallery: {
    currentTabLabel: "Aktuelle Vorschläge",
    upload: "Hochladen",
    uploadDialogHeading: "Laden Sie ein neues Element für Vorschläge hochladen",
    uploadImage: "Bild Hochladen",
    dropHere: "HIER ABLEGEN",
    adLink: "Anzeigenlink",
    count: "Anzahl",
    testedLinksButtonText: "Hier wurde das Bild bereits gestet",
    testedLinks: "Testet Links",
    addNewTestedLink: "Neues testet link hinzufügen",
    uploadedSuccessfully: "Hochgeladen Erfolgreich!",
    noteLabel: "Notiz",
    linkToCampaignLabel: "Link zur Kampagne",
    linkToFunnelLabel: "Link zur Funnel",
    archiveModal: {
      heading: "Vorschlags {{what}}",
      msg: `Sind Sie sicher, dass Sie diese Vorschlags <strong class="text-danger">{{what}}</strong> möchten?`,
      multiHeading: "Vorschläge {{what}}",
      multiMsg: `Sind Sie sicher, dass Sie diese Vorschläge <strong class="text-danger">{{what}}</strong> möchten?`
    },
    winningModal: {
      mark: "ansehen",
      remove: "entfernen",
      msg: `Sind Sie sicher, dass Sie diesen Vorschlag als Gewinner {{what}} möchten?`
    }
  },
  countries: {
    title: "Länder",
    intro:
      "Länder, die in der Länderauswahl der Funnels angeboten werden. Änderungen gelten für alle Workspaces.",
    addCountry: "Land hinzufügen",
    addAnotherCountry: "Weiteres Land",
    editCountry: "Land bearbeiten",
    actions: {
      edit: "Bearbeiten",
      hide: "Ausblenden",
      show: "Einblenden"
    },
    chooseMapImage: "Kartenbild wählen",
    errors: {
      nameRequired: "Bitte einen Namen angeben",
      nameTaken: "Name ist bereits vergeben",
      countryRequired: "Bitte mindestens ein Land angeben",
      dialCodeRequired: "Bitte eine Vorwahl angeben",
      dialCodeFormat: "Vorwahl im Format +49 angeben",
      digitsRequired: "Bitte mindestens eine PLZ-Stellenzahl angeben",
      digitsFormat: "PLZ-Stellen müssen ganze Zahlen von 3 bis 10 sein",
      mapRequired: "Bitte ein Kartenbild auswählen"
    },
    columns: {
      name: "Name",
      countries: "Länder",
      dialCode: "Vorwahl",
      postalCodeDigits: "PLZ-Stellen",
      mapImage: "Karte",
      status: "Status"
    },
    bundledMap: "Standard",
    statusActive: "Aktiv",
    statusHidden: "Ausgeblendet"
  },
  formDefaults: {
    title: "Formular-Standards",
    intro:
      "Globale Standards des klassischen Bestellformulars je Funnel-Typ. Gewinner von Split-Tests für Farben und Vertrauenselemente landen hier; Funnels folgen ihnen, solange sie keinen eigenen Wert tragen.",
    submitButtonBackground: "Button-Farbe",
    formHeaderBackground: "Kopfzeilen-Farbe",
    hardCoded: "Standard",
    followsDefault: "folgt dem globalen Standard",
    socialProof: "Social-Proof-Zeile (echte Anfragen der Kategorie)",
    googleRating: "Google-Bewertung des Betriebs",
    templateHint: "Platzhalter {{count}} (Pflicht) und {{category}}.",
    minCount: "Anzeigen ab (Anfragen)",
    windowDays: "Zeitraum (Tage)",
    minRating: "Mindest-Bewertung",
    minReviews: "Mindest-Anzahl Bewertungen",
    stateDefault: "Standard (Seiteneinstellungen)",
    stateOn: "An",
    stateOff: "Aus",
    lastSet: "zuletzt gesetzt {{date}}",
    bySplitTest: "durch Split-Test",
    saved: "Formular-Standards gespeichert"
  },
  fulfillmentKpis: {
    title: "Fulfillment-Kennzahlen",
    intro:
      "Monatswerte der letzten {{months}} Monate und des laufenden Monats. Die Zahlen werden höchstens alle {{minutes}} Minuten neu berechnet.",
    running: "läuft",
    target: "Ziel {{value}} %",
    customer: "Kunde",
    loadError: "Die Kennzahlen konnten nicht geladen werden.",
    retry: "Erneut laden",
    campaign: {
      title: "Kampagnenstart in {{days}} Tagen",
      help: "Erstverträge in HubSpot (Fulfillment-Pipeline, kein Upsell), deren Kampagne spätestens {{days}} Tage nach dem Vertragsdatum aktiv geschaltet wurde („Kampagne aktiv Datum“). Monat = Vertragsmonat.",
      tile: "Kampagnenstart in {{days}} Tagen · {{month}} · Ziel {{target}} % · Median {{median}} Tage",
      series: "Anteil rechtzeitig gestartet",
      tooltip:
        "Erstverträge: {{cohort}} · rechtzeitig {{inTime}} · später {{late}} · ohne Start {{notStarted}} · offen {{open}}",
      withoutTitle: "Erstverträge ohne Kampagnenstart (ab Tag {{days}})",
      deal: "HubSpot-Deal",
      contractDate: "Vertragsdatum",
      days: "Tage seit Vertrag",
      stage: "Phase",
      noAccess:
        "HubSpot nicht verbunden: Das Cockpit hat noch keinen Lesezugriff auf HubSpot-Deals.",
      unavailable:
        "HubSpot konnte nicht gelesen werden. Bitte später erneut versuchen.",
      truncated:
        "Nicht alle Erstverträge aus HubSpot gelesen. Quote und Liste sind unvollständig."
    },
    start: {
      title: "Erste Anfrage in {{days}} Tagen",
      help: "Neukunden aus HubSpot, deren erste Anfrage spätestens {{days}} Tage nach Anlage im Cockpit eingeht. Monat = Anlagemonat.",
      tile: "Erste Anfrage in {{days}} Tagen · {{month}} · Median {{median}} Tage",
      series: "Anteil mit erster Anfrage rechtzeitig",
      tooltip:
        "Neukunden: {{cohort}} · rechtzeitig {{inTime}} · später {{late}} · ohne Anfrage {{notStarted}} · offen {{open}}"
    },
    withoutStart: {
      title: "Neukunden ohne erste Anfrage (ab Tag {{days}})",
      createdAt: "Angelegt am",
      days: "Tage seit Anlage",
      funnels: "Funnels",
      funnelCount: "{{count}} (davon {{drafts}} Entwurf)"
    },
    leads: {
      title: "Kunden mit ≥ {{min}} Anfragen",
      help: "Kunden mit mindestens einer an ContactCloud übergebenen Anfrage im Monat, ab ihrem ersten vollen Monat.",
      tile: "≥ {{min}} Anfragen · {{month}} · {{customers}} Kunden",
      tileTarget: "≥ {{min}} Anfragen (Ziel)",
      series: "≥ {{min}} Anfragen",
      tooltip: "Kunden im Monat: {{customers}}"
    },
    below: {
      title: "Kunden unter {{min}} im laufenden Monat",
      running: "Anfragen laufender Monat",
      previous: "Anfragen Vormonat"
    }
  },
  splitTests: {
    title: "Split-Tests",
    intro:
      "Ein Element des Bestellformulars (Text, Farbe oder Vertrauenselement) wird über alle Funnels dieses Typs getestet (50/50 je Besucher). Ein signifikanter Gewinner wird automatisch ausgerollt, danach folgt der nächste Vorschlag.",
    tabs: { lead: "Neukunden", employee: "Mitarbeiter" },
    variant: { A: "Kontrolle (aktuell)", B: "Variante" },
    status: {
      PROPOSED: "Vorschlag",
      RUNNING: "Läuft",
      WON: "Gewonnen",
      LOST: "Verloren",
      NO_DIFFERENCE: "Kein Unterschied",
      CANCELLED: "Abgebrochen",
      REVERTED: "Zurückgenommen"
    },
    log: {
      STARTED: "Test gestartet",
      CONTINUE: "Auswertung: noch nicht signifikant",
      WON: "Variante B gewinnt",
      LOST: "Kontrolle A gewinnt",
      NO_DIFFERENCE: "Kein Unterschied, Kontrolle bleibt",
      CANCELLED: "Abgebrochen",
      REVERTED: "Roll-out zurückgenommen"
    },
    types: { text: "Texte", color: "Farben", feature: "Elemente" },
    feature: { on: "an", off: "aus" },
    fields: {
      element: "Element",
      controlValue: "Kontrolltext (A)",
      variantValue: "Variantentext (B)",
      controlColor: "Aktuelle Farbe (A)",
      variantColor: "Variantenfarbe (B)",
      template: "Social-Proof-Vorlage (B)",
      hypothesis: "Hypothese",
      rationale: "Begründung",
      mde: "Mindest-Effekt (relativ)"
    },
    running: {
      title: "Laufender Test",
      since: "Gestartet {{date}} · läuft seit {{days}} Tagen",
      eligible: "{{count}} teilnehmende Funnels",
      log: "Entscheidungsprotokoll",
      emptyTitle: "Es läuft kein Test",
      emptyText: "Starte den Vorschlag unten oder lege einen Test manuell an."
    },
    stats: {
      exposures: "Formular gesehen",
      conversions: "Leads",
      rate: "Conversion",
      lift: "Lift B vs. A",
      ci: "95 %-Intervall",
      pValue: "p-Wert",
      threshold: "signifikant unter 0,0294 (zwei Auswertungen)",
      sampleSize: "Besucher je Variante",
      baseline: "bei {{rate}} Basis, +{{mde}} Effekt",
      sampleAfter48h: "wird 48 h nach Start festgelegt",
      projectedDays: "Tage bis zur Auswertung",
      lookOf: "Auswertung {{look}} von 2",
      progress:
        "{{current}} von {{target}} Besuchern in der kleineren Variante",
      rule: "Entscheidung bei n und 2n Besuchern je Variante, frühestens nach 7, spätestens nach 28 Tagen."
    },
    proposal: {
      section: "Nächster Vorschlag",
      title: "Nächster Vorschlag",
      editTitle: "Vorschlag bearbeiten",
      manualTitle: "Test manuell anlegen",
      empty:
        "Noch kein Vorschlag. Lass die KI das nächste Element vorschlagen oder lege selbst einen Test an.",
      waitForRunning:
        "Für diesen Funnel-Typ läuft ein Test. Der nächste kann starten, sobald er beendet ist.",
      noEligible:
        "Kein aktiver Funnel trägt diesen Kontrolltext, der Test würde niemanden erreichen. Wähle einen anderen Kontrolltext.",
      sourceAi: "KI-Vorschlag",
      sourceManual: "Manuell",
      baselineHint: "{{count}} aktive Funnels",
      funnels: "Funnels",
      mdeShort: "Mindest-Effekt +{{mde}} %",
      sampleShort: "≈ {{n}} Besucher je Variante",
      colorControlHint:
        "Der aktuelle globale Standard des Funnel-Typs (oder die fest eingebaute Farbe); Funnels mit eigener Farbe nehmen nicht teil.",
      featureControlHint:
        "Kontrolle = Element aus (aktueller Standard), Variante = Element an. Es nehmen nur Funnels teil, die dem Standard folgen und das Element anzeigen können.",
      featureEligible: "{{count}} Funnels können das Element heute anzeigen.",
      sampleEstimate:
        "≈ {{n}} Besucher je Variante bei {{rate}} Basis-Conversion (die genaue Zahl wird 48 h nach dem Start festgelegt)."
    },
    history: {
      title: "Historie",
      texts: "Texte",
      result: "Ergebnis",
      runtime: "Laufzeit",
      rollout: "Ausgerollt",
      visitors: "Besucher",
      days: "Tage",
      rolledOutTo: "{{funnels}} Funnels, {{templates}} Vorlagen",
      rolloutPending: "Roll-out fehlgeschlagen, erneut ausführen",
      emptyTitle: "Noch keine abgeschlossenen Tests",
      emptyText:
        "Abgeschlossene Tests erscheinen hier mit Lift, p-Wert und Roll-out."
    },
    actions: {
      propose: "Vorschlag erzeugen",
      proposeAgain: "Neuer Vorschlag",
      createManual: "Manuell anlegen",
      edit: "Bearbeiten",
      start: "Test starten",
      cancel: "Test abbrechen",
      evaluateNow: "Jetzt auswerten",
      preview: "Vorschau",
      revert: "Roll-out zurücknehmen",
      retryRollout: "Roll-out wiederholen"
    },
    confirm: {
      startTitle: "Split-Test starten?",
      startText:
        "Das Element {{element}} wird 50/50 auf {{count}} aktiven Funnels getestet. Der Gewinner wird automatisch ausgerollt.",
      cancelTitle: "Split-Test abbrechen?",
      cancelText:
        "Der Test endet ohne Entscheidung. Es wird nichts ausgerollt.",
      revertTitle: "Roll-out zurücknehmen?",
      revertText:
        "Der Kontrolltext wird auf {{funnels}} Funnels (und den Vorlagen) wiederhergestellt, die noch den Gewinnertext tragen.",
      rolloutTitle: "Roll-out wiederholen?",
      rolloutText:
        "Der Gewinnertext wird in alle aktiven Funnels (und Vorlagen) dieses Typs geschrieben, die noch den Kontrolltext tragen."
    },
    toast: {
      proposed: "Vorschlag erzeugt",
      created: "Test angelegt",
      saved: "Vorschlag gespeichert",
      started: "Test gestartet",
      cancelled: "Test abgebrochen",
      stillRunning:
        "Ausgewertet: noch keine Entscheidung, der Test läuft weiter",
      decided: "Entscheidung: {{status}}",
      reverted: "Roll-out zurückgenommen",
      rolledOut:
        "Roll-out erledigt: {{funnels}} Funnels, {{templates}} Vorlagen"
    }
  },
  leadservicePanel: {
    onHoldHeading: "Offene Anfrage",
    onHoldInfoMsg: "Anzahl Leads in der Wiedervorlage",
    currentlyDisabledWarning:
      "Leadservice dieses Funnel ist derzeit deaktiviert",
    leadService: "Lead Service",
    appointment: "Terminbestätigung"
  },
  aiLeadservice: {
    lead: {
      heading: "AI Leadservice (LEAD - Neukunden)",
      enabledSuccess: "AI Leadservice (LEAD) Aktivierung aktualisiert",
      enabledError:
        "Fehler beim Aktualisieren der AI Leadservice (LEAD) Aktivierung",
      webhookSuccess: "AI Leadservice (LEAD) Webhook aktualisiert",
      webhookError:
        "Fehler beim Aktualisieren des AI Leadservice (LEAD) Webhooks",
      triggerSuccess: "AI Leadservice (LEAD) Trigger aktualisiert",
      triggerError:
        "Fehler beim Aktualisieren des AI Leadservice (LEAD) Triggers"
    },
    employee: {
      heading: "AI Leadservice (EMPLOYEE - Mitarbeitergewinnung)",
      enabledSuccess: "AI Leadservice (EMPLOYEE) Aktivierung aktualisiert",
      enabledError:
        "Fehler beim Aktualisieren der AI Leadservice (EMPLOYEE) Aktivierung",
      webhookSuccess: "AI Leadservice (EMPLOYEE) Webhook aktualisiert",
      webhookError:
        "Fehler beim Aktualisieren des AI Leadservice (EMPLOYEE) Webhooks",
      triggerSuccess: "AI Leadservice (EMPLOYEE) Trigger aktualisiert",
      triggerError:
        "Fehler beim Aktualisieren des AI Leadservice (EMPLOYEE) Triggers"
    },
    webhookIntegrationLabel: "Webhook Integration",
    webhookUrlLabel: "Webhook-URL",
    attemptsLabel: "Nach wie vielen Versuchen",
    trackingGlobalHeading: "Lead Service Tracking Global"
  },
  leadserviceReport: {
    label: "Slack-Webhook Tagesbilanz (Mo–Fr 18:00)",
    configured: "gesetzt",
    notConfigured: "nicht gesetzt",
    updatedAt: "geändert {{date}}",
    hint: "Incoming Webhook des Leadservice-Slack-Kanals oder ein Zapier Catch Hook, der dorthin weiterleitet. Die URL wird sicher gespeichert und nicht wieder angezeigt.",
    saved: "Slack-Webhook gespeichert",
    remove: "Entfernen",
    removeConfirm:
      "Hinterlegten Webhook entfernen? Die Tagesbilanz wird nicht mehr gepostet, bis ein neuer gespeichert wird.",
    removed: "Webhook entfernt",
    removeError: "Webhook konnte nicht entfernt werden",
    saveError: "Slack-Webhook konnte nicht gespeichert werden",
    sendTest: "Testnachricht senden",
    testSent: "Testnachricht gesendet – bitte im Slack-Kanal prüfen",
    testNotSent: "Testnachricht konnte nicht gesendet werden"
  },
  adLinkPlaceholder: "Link zum Werbekonto einfügen",
  uploadScriptDialog: {
    uploadPDF: "Hochladen PDF"
  },
  textElementsTelephoneCheck: {
    switchLabel: "Telefonnummer in 2-Schritten abfragen",
    screenHeadline: "Telefon-Screen Überschrift"
  },
  textElementsImageCheck: {
    switchLabel: "Aktivieren Formular-Bild",
    fieldLabel: "Formular-Bild",
    placementRadioLabel: "Platzierung Formular-Bild",
    radioBeforeLabel: "Vor Formular Subheadline",
    radioAfterLabel: "Nach Formular Subheadline"
  },
  leadTabs: {
    leads: "Leads",
    incompleteLeads: "Unvollständige Leads",
    numberOfEmailsSentLabel: "Anzahl der E-Mail gesendet"
  },
  customerTabs: {
    customer: "Kunden",
    cockpitCustomers: "Kunden",
    hubSpotCustomers: "Hubspot Kunden"
  },
  policySection: {
    switchLabel: "Abschnitt Richtlinie anzeigen",
    toBeShownTooltip: "Der Richtlinienteil wird angezeigt",
    notToBeShownTooltip: "Der Richtlinienteil wird nicht angezeigt",
    textFieldPlaceholder: "Gib den Text zur Anzeige als Richtlinientext ein",
    checkboxText: "Checkbox-Text",
    clickableKeyword: "Klickbarer Text",
    modalContent: "Modal Inhalt"
  },
  incompleteLeadDialog: {
    title: "Löschen Unvollständiger Lead",
    msg: "Möchten Sie diese <strong>löschen</strong>?"
  },
  editorModal: {
    deleteConfirmationMsg:
      "Bist Du Dir sicher, dass Du den {{what}} <strong>löschen</strong> möchten?"
  },
  preLandingPage: {
    duplicateLabel: "Dupliziere",
    duplicateSubLabel: "Dupliziere die Pre Lading Page in einen anderen Funnel",
    duplicateSuccessMsg: `Pre Landing Page {{funnelName}} wurde erfolgreich dupliziert`,
    duplicateDisabledTooltip: "Deine Änderungen bist nicht gespeichert!",
    sameFunnelWarning: "Du befindest dich derzeit auf demselben Funnel",
    enableSwitchLabel: "Pre-Landingpage einschalten",
    enableSwitchDialogMsg: `Sind Sie sicher, dass Sie Pre-Landingpage <strong class="text-danger">aktivieren</strong> möchten?`,
    disableSwitchDialogMsg: `Sind Sie sicher, dass Sie Pre-Landingpage <strong class="text-danger">deaktivieren</strong> möchten?`,
    selectTemplateLabel: "Template auswählen",
    templateOneOptLabel: "Vorlage 1 (Bild/Text - Untereinander)",
    templateTwoOptLabel: "Vorlage 2 (Bild/Text - Nebeneinander)",
    deletePointMessage: `Sind Sie sicher, dass Sie diese Point <strong class="text-danger">löschen</strong> möchten?`,
    deletePointSuccess: "Hero Content Point erfolgreich gelöscht.",
    deleteBenefitMessage: `Sind Sie sicher, dass Sie diese Benefit <strong class="text-danger">löschen</strong> möchten?`,
    deleteBenefitSuccess: "Benefit erfolgreich gelöscht."
  },
  preLandingPageOne: {
    headerBgColorLabel: "Hintergrund Farbe des Firmenlogos",
    headlineTextLabel: "Überschrift (ganz oben)",
    headlineColorLabel: "Überschrift Farbe (ganz oben)",
    heroHeadlineTextLabel: "Unterüberschrift (ganz oben)",
    heroHeadlineTextColorLabel: "Unterüberschrift Farbe (ganz oben)",
    heroContentLabel: "Textblock unter dem Bild",
    heroImageLabel: "Grafik der Landingpage",
    ctaButtonTextLabel: "CTA Button Text",
    ctaButtonTextColorLabel: "CTA Text Farbe im Button",
    ctaButtonBackgroundColor: "CTA Button Farbe",
    benefits: {
      benefitsGridHeadline: "Überschrift der Benefits",
      benefitsGridHeadlineColor: "Benefit Überschrift Farbe",
      benefitsGridTextColor: "Benefit Text Farbe",
      benefitsGridSubHeadline: "Unterüberschrift der Benefits",
      benefitsGridLabel: "Benefits Auflistung",
      addNewBenefitBtn: "Benefit hinzufügen",
      label: "Überschrift",
      subtext: "Unterüberschrift",
      icon: "Icon",
      selectBtn: "Auswählen"
    },
    footerContent: "Fußbereichs content"
  },
  preLandingPageTwo: {
    backgroundImageLabel: "Hintergrund Grafik",
    centerContentBackgroundColorLabel:
      "Hintergrundfarbe vom Element für die Schriften",
    centerContentBackgroundOpacityLabel: "Hintergrund Element Deckkraft",
    contactUsButtonTextLabel: "Button Text (oben rechts)",
    contactUsButtonColorLabel: "Button Schriftfarbe (oben rechts)",
    contactUsButtonBackgroundHoverLabel: "Button Hover Farbe (oben rechts)",
    phoneNumberHeadlineLabel: "Überschrift Telefonnummer",
    phoneNumberTextLabel: "Telefonnummer",
    phoneNumberColorLabel: "Telefonnummer Schriftfarbe",
    subHeadlineTextLabel: "Unterüberschrift Text",
    subHeadlineColorLabel: "Unterüberschrift Farbe",
    heroContentLabel: "Textfeld (links vom Bild)",
    heroImageLabel: "Hauptbild (Zentral)",
    heroPoints: {
      headingLabel: "Aufzählungspunkte neben dem Bild hinzufügen (Maximal 3)",
      btnLabel: "Aufzählungspunkte neben dem Bild hinzufügen",
      label: "Aufzählungspunkt in Fettschrift (Links)",
      text: "Aufzählungspunkt in normaler Schrift (Rechts)"
    },
    footerMapLabel: "Karte Einbetten bei Google Maps",
    heroContentTextColorLabel: "Schriftfarbe Text links vom Bild",
    heroContentIconColorLabel: "Schriftfarbe Icon links vom Bild"
  },
  customerWebsite: {
    website: "Website",
    duplicate: "Duplikat",
    brandColors: {
      heading: "Markenfarben",
      warning:
        "Durch das Ändern einer Markenfarbe werden die unten voreingestellten Werte überschrieben, einschließlich aller zuvor angepassten Farben für Überschriften oder Text",
      headingDark: "Dunkle Überschrift",
      headingLight: "Richtungslicht",
      textPrimary: "Text primär",
      textSecondary: "Text sekundär",
      textLight: "Textlicht",
      buttonPrimary: "Button Primary",
      buttonSecondary: "Schaltfläche Primär",
      buttonBGPrimary: "Schaltfläche Hintergrund Primär",
      buttonBGSecondary: "Schaltfläche Hintergrund sekundär",
      primaryBG: "Primärer Hintergrund",
      secondaryBG: "Sekundärer Hintergrund"
    },
    sections: {
      hero: "Startbereich",
      about: "Über uns",
      service: "Diensleistungen",
      banner: "Banner 1 (Text auf dem Bild)",
      keyPoint: "Kernpunkte",
      secondBanner: "Banner 2 (Text neben dem Bild)",
      map: "Karte",
      faq: "FAQs"
    },
    section: "Abschnitt",
    addSection: "Neuen Abschnitt hinzufügen",
    deleteSection: "Abschnitt löschen",
    deleteSectionMessage: "Möchten Sie diesen Abschnitt wirklich löschen?",
    selectSection: "Abschnitt auswählen",
    deleteFavicon: "Favicon löschen",
    deleteFaviconMessage:
      "Möchten Sie das Favicon wirklich löschen? Diese Aktion ist unumkehrbar und das Favicon wird dauerhaft entfernt.",
    logo: {
      heading: "Logo",
      logoType: "Logo-Typ",
      logoText: "Logo-Text",
      logoColor: "Logofarbe",
      logoImage: "Logobild",
      logoScale: "Logo-Skalierung"
    },
    navLinks: "Nav-Links",
    linksTextColor: "Textfarbe für Links",
    link: "Bereich",
    text: "Text",
    contact: "Kontakt",
    phone: "Telefon",
    phoneIconColor: "Farbe des Telefonsymbols",
    address: "Adresse",
    addressIconColor: "Farbe des Adresssymbols",
    template: "Vorlage",
    preview: "Vorschau",
    header: "Kopfzeile",
    BGColor: "Hintergrundfarbe",
    heading: "Überschrift",
    headingColor: "Überschriftenfarbe",
    para: "Absatz",
    paraColor: "Absatzfarbe",
    bullet: "Kugel",
    bulletsColor: "Farbe der Kugeln",
    image: "Bild",
    images: "Bilder",
    addImage: "Bild hinzufügen",
    mobileSortingLogic: "Mobile Sortierlogik",
    mobileSortingHorizontal: "Horizontal (Zeilen)",
    mobileSortingVertical: "Vertikal (Spalten)",
    mobileSortingLogicTooltip:
      "Horizontal behält die Bildreihenfolge 1, 2, 3 bei. Vertikal zeigt zuerst die erste Desktop-Spalte, z. B. 1, 4, 7.",
    ctaBtnText: "CTA Schaltflächentext",
    ctaBtnLink: "CTA Schaltflächenlink",
    ctaBtnColor: "CTA Tastenfarbe",
    ctaBtnBGColor: "CTA Hintergrundfarbe der Schaltfläche",
    ctaBtnTwoText: "CTA 2 Schaltflächentext",
    ctaBtnTwoLink: "CTA 2 Schaltflächenlink",
    ctaBtnTwoColor: "CTA 2 Tastenfarbe",
    ctaBtnTwoBGColor: "CTA 2 Hintergrundfarbe der Schaltfläche",
    BGImage: "Hintergrundbild",
    mapMessage:
      "Kopieren Sie das iframe von Google Maps und fügen Sie es hier ein.",
    mapLink: "Kartenrahmen",
    qAndA: "Fragen und Antworten",
    q: "Frage",
    a: "Antwort",
    add: "Hinzufügen",
    addQ: "Frage hinzufügen",
    qColor: "Fragefarbe",
    aColor: "Antwortfarbe",
    footer: "Fußzeile",
    taglineText: "Slogan-Text",
    taglineColor: "Farbe des Slogans",
    fbLink: "Facebook-Link",
    fbColor: "Facebook-Symbolfarbe",
    instaLink: "Instagram-Link",
    instaColor: "Instagram-Symbolfarbe",
    ytLink: "Youtube-Link",
    videoSwitch: "Video statt Bild anzeigen",
    videoLink: "Video-Link (YouTube oder Wistia)",
    videoLinkPlaceholder:
      "z. B. https://youtu.be/… oder https://am-beratung.wistia.com/s/…",
    videoLinkHelp:
      "Wistia: in Wistia auf „Teilen“ klicken und den Link kopieren.",
    ytColor: "Youtube-Symbolfarbe",
    x_twitterLink: "X/Twitter-Link",
    x_twitterColor: "X/Twitter-Symbolfarbe",
    pinterestLink: "Pinterest-Link",
    pinterestColor: "Pinterest-Symbolfarbe",
    tiktokLink: "Tiktok-Link",
    tiktokColor: "Tiktok-Symbolfarbe",
    linkedinLink: "LinkedIn-Link",
    linkedinColor: "LinkedIn-Symbolfarbe",
    socialLinks: "Soziale Links",
    quickLinks: "Übersicht Links",
    policyLinks: "Richtlinienlinks",
    privacyPolicy: "Datenschutz",
    legalNotice: "Impressum",
    agbSwitchLabel: "AGB anzeigen (optional)",
    legalPagesSwitchLabel: "Als eigene Seiten anzeigen (statt Pop-up)",
    legalPagesHelp:
      "Die Texte sind dann unter {{urls}} erreichbar. Ist unter „Bereich“ ein Link hinterlegt, öffnet der Footer weiterhin diesen Link.",
    legalPagesHelpNone:
      "Noch keine eigene Seite: Ein Rechtstext wird zur Seite, sobald er Inhalt und keinen Link unter „Bereich“ hat.",
    legalPagesYourDomain: "ihre-domain.de",
    legalPageContentMissing: "Für die eigene Seite fehlt der Inhalt.",
    reservedTabRoute: "Diese Route ist für die Rechtstexte reserviert.",
    tabRoutesLoadFailed:
      "Die Reiter des Kunden konnten nicht geladen werden. Die Route wird beim Speichern geprüft.",
    name: "Name",
    nameColor: "Namensfarbe",
    title: "Titel",
    titleColor: "Titelfarbe",
    phoneColor: "Telefonfarbe",
    saveWebsite: "Webseite speichern",
    savingWebsite: "Webseite speichern",
    cloneDialogHeading: "Vorlage für einen anderen Kunden klonen",
    policies: "Rechtliches",
    unclipImage: "Ausclipsen Bild",
    replaceWarning: {
      title: "Warnung",
      para: "Möchten Sie die bestehende Website dieses Kunden überschreiben?",
      btn: "Ja",
      saving: "Sparen..."
    },
    btnSameBGColorError:
      "Die Farbe des Schaltflächentexts und des Hintergrunds sollte ausreichend Kontrast aufweisen",
    script: {
      label: "Skript",
      head: "Kopf",
      body: "Körper"
    },
    errors: {
      customerCreationError: "Fehler beim Erstellen des Hubspot-Kunden",
      aiContentError: "Fehler beim Generieren von AI-Inhalten"
    },
    RECEIVED: "Empfangen",
    PROCESSING: "In Bearbeitung",
    COMPLETED: "Abgeschlossen",
    FAILED: "Fehlgeschlagen",
    favIconSuggestionText: "Nur im Website-Base-Tab bearbeitbar",
    footerBanner: "Fußbereichsbanner",
    footerBannerLabel: "A&M Fußzeilenbanner anzeigen"
  },
  versionDialogMsg: {
    changeVersionAndLandingPage:
      "<div>Die Landingpage in dieser Version <strong>unterscheidet</strong> sich von der aktuellen Version.</div><div>Möchtest du fortfahren und die Landingpage <strong>aktualisieren?</strong></div>",
    changeVersionAndDisableLandingPage:
      "<div>In dieser Version ist keine Pre-Landingpage verknüpft.</div><div>Soll die Pre-Landingpage trotzdem <strong>deaktiviert</strong> werden?</div>",
    changeVersionAndEnableLandingPage:
      "<div>In dieser Version ist eine aktive Pre-Landingpage verknüpft.</div><div>Soll die Pre-Landingpage trotzdem <strong>aktiviert</strong> werden?</div>",
    default: `Bist Du Dir sicher, dass Du die Funnel-Version <span class="fw-bold">aktivieren</span> möchten?`
  },
  deleteIntegration: "Integration entfernen",
  disableLeadServiceModal: {
    heading: "Deaktivieren Lead Service",
    associatedIntegrationMsg: `Diese Lead Service ist mit <strong>{{count}} Leads</strong> verknüpft, die noch nicht weitergeleitet wurden`,
    syncNowAndDisable: "Leads direkt weiterleiten und Leadservice entfernen",
    disableNowAndSyncLater:
      "Intergration entfernen (Leads bleiben im Leadservice)"
  },
  lastTaskLabel: "Letzter Task",
  budgetSectionLabels: {
    lead: "Neukundengewinnung",
    employee: "Mitarbeitergewinnung"
  },
  selectRangeLabel: "Zeitraum auswählen",
  tagform: {
    cancel: "Abbrechen",
    save: "Speichern",
    uneditableSystemTagMessage:
      "Dies ist ein Systemtag und kann nicht bearbeitet werden"
  },
  addressAfterLeadgen: {
    switchLabel: "Adressabfrage nach Lead-Generierung aktivieren",
    fieldLabel: "Bezeichnung für das Adressfeld",
    fieldPlaceholder: "Bezeichnung für das Adressfeld eingeben",
    submitBtnFieldLabel: "Bezeichnung für den Senden-Button",
    submitBtnFieldPlaceholder: "Bezeichnung für den Senden-Button eingeben"
  },
  campaignsReview: {
    title: "Kampagnenbewertung",
    spend: "Budget",
    positive: "Geeignete Anfragen",
    negative: "Nicht geeignete Anfragen",
    noStage: "Keine Phase",
    neutral: "Nicht bewertbare Anfragen"
  },
  lsTypeFilters: {
    all: "Alle Leads",
    leadService: "Lead Service",
    leadServicePlus: "Lead Service Plus",
    leadServicePlusWithAppointment: "Lead Service Plus & Terminierung"
  },
  notSutablePie: {
    title: "Aufteilung der nicht geeigneten Anfragen"
  },
  website: {
    analyticsHeading: "Analysen",
    keyMetrics: "Kennzahlen",
    totalVisitCount: "Gesamtanzahl der Besuche",
    uniqueVisitCount: "Eindeutige Besucheranzahl",
    totalCTAClicks: "Gesamtanzahl CTA-Klicks",
    totalNonCTAClicks: "Gesamtanzahl Nicht-CTA-Klicks",
    leads: "Leads",
    funnels: "Funnels",
    assignFunnels: "Funnels zuweisen",
    noFunnelsAssigned: "Noch keine Funnels zugewiesen",
    noWebsiteFound: "Keine Website gefunden",
    ctaConversionRate: "Conversion Rate auf CTA-Button",
    leadConversionRate: "Conversion Rate auf Leads",
    visitsWithoutCtaClick: "Besuche ohne CTA-Klick",
    visitsWithoutLead: "Besuche ohne Lead",
    CTAInfo: "CTA-Informationen",
    nonCTAInfo: "Nicht-CTA-Informationen",
    allTime: "Gesamter Zeitraum",
    footerEmail: "Footer-E-Mail",
    footerPhone: "Footer Telefon",
    navbarPhone: "Navigationsleiste Telefon",
    navbarPhoneTwo: "Navigationsleiste Telefon 2",
    footerContact: "Footer-Kontakte",
    footerContactTwo: "Footer-Kontakte 2"
  },
  localSeo: {
    pageTitle: "Local SEO",
    submitBtn: "Local SEO Content erstellen",
    locationLabel: "Hauptstandort",
    locationPlaceholder: "Stadt eingeben",
    addNewLocationBtn: "weiteren Ortsteil hinzufügen",
    serviceKeywordLabel: "Keywords / Produkte",
    serviceKeywordPlaceholder: "Keyword oder Produkt eingeben",
    addNewKeywordBtn: "weiteren Service hinzufügen",
    delDialogHeading: "Löschen Bestätigung",
    renderDelGeneratedCityDialogMsg:
      "Durch das Löschen dieser Stadt werden alle zugehörigen Unterseiten entfernt. Möchten Sie fortfahren?",
    populateCustomerCityLabel: "aus Kundendaten füllen",
    deleteGeneratedFieldMsg:
      'Warnung: Das Löschen dieses <span class="fw-bold">Feld</span> wird <span class="fw-bold text-danger">auch die zugehörigen Unterseiten löschen</span>.',
    renderDelGeneratedSubPageDialogMsg:
      "Sind Sie sicher, dass Sie diese generierte Unterseite löschen möchten?",
    progressCompleted: "Abgeschlossen",
    progressStarting: "Beginnt",
    progressRetrying: "Wiederholungsversuch",
    progressRetrySuccess: "Wiederholung erfolgreich",
    failed: "Fehlgeschlagen",
    retry: "Wiederholung",
    successful: "Erfolgreich",
    retryDialogHeading: "Wiederholung Bestätigung",
    retryDialogMsg:
      "Diese Unterseite wurde nicht generiert. Möchten Sie es erneut versuchen?",
    editPageTitle: "Seitentitel",
    seoTitle: "SEO-Titel",
    seoDescription: "SEO-Beschreibung",
    sections: "Abschnitte",
    heading: "Überschrift",
    paragraph: "Absatz",
    renderDelNonGeneratedSubPageDialogMsg:
      "Diese Seite wurde nicht generiert. Möchten Sie sie wirklich löschen?"
  },
  exportQueries: {
    notSuitableExportDescription:
      "Export eine CSV-Datei mit als nicht geeigneten markierten Leads der letzten 90 Tage, gefiltert nach bestimmten Gründen und Kategorien sowie unter Ausschluss bestimmter Postleitzahlen und tenant-IDs."
  },
  privacyPolicy: {
    activateLabel: "Hausflix Datenschutz Formular aktivieren",
    tabName: "Hausflix Datenschutz",
    checkboxTextLabel: "Kontrollkästchentext",
    clickableKeywordLabel: "Anklickbares Schlüsselwort",
    modalHeadingLabel: "Modale Überschrift",
    modalContentLabel: "Modal Inhalt"
  },
  offerFollowupAgent: {
    outcomes: {
      suitable: "Qualifiziert",
      not_suitable: "Nicht geeignet",
      callback_required: "Lead später kontaktieren",
      not_reached: "Nicht erreicht"
    },
    call: "Anruf",
    nextAttempt: "Nächster Versuch:",
    nextAttemptAfter: "Nächster Versuch nach: {{date}}",
    activityCreatedAt: "Erstellt am:",
    noActivities: "Bisher keine Aktivitäten für diesen Lead!",
    calling: "Anrufen...",
    errors: {
      loadLead: "Angebotsnachfass-Lead konnte nicht geladen werden",
      startCall: "Anruf konnte nicht gestartet werden",
      invalidDecision: "Ungültige Entscheidung",
      notesLength: "Agentennotizen müssen mindestens 20 Zeichen lang sein.",
      callbackTime:
        "Der nächste Versuch muss mindestens 4 Stunden in der Zukunft liegen.",
      callNotAllowedYet: "Dieser Lead kann nach {{date}} angerufen werden.",
      saveOutcome: "Nachfassergebnis konnte nicht gespeichert werden",
      searchLeads: "Angebotsnachfass-Leads konnten nicht gesucht werden"
    },
    saved: "Angebotsnachverfolgung gespeichert.",
    emptyQueue: "Keine ausstehenden Angebotsnachfass-Leads.",
    refreshQueue: "Warteschlange aktualisieren",
    searchBy: "Suchen nach",
    search: "Suchen",
    searchedBy: "Gesucht über: {{type}}",
    searchTypes: {
      phone: "Telefon",
      email: "E-Mail"
    },
    lead: "Lead",
    createdAt: "{{date}} Uhr",
    company: "Unternehmen",
    tenant: "CC-Mandant",
    offerSentAt: "Angebot gesendet am",
    today: "(Heute)",
    daysAgo_one: "(vor 1 Tag)",
    daysAgo_other: "(vor {{count}} Tagen)",
    product: "Produkt",
    offerVolume: "Angebotsvolumen",
    callContact: "Kontakt anrufen",
    callRestrictedNote: "Dieser Lead sollte nach {{date}} angerufen werden.",
    notReached: "Nicht erreicht",
    contactLater: "Lead später kontaktieren",
    qualified: "Qualifiziert",
    notSuitable: "Nicht geeignet",
    notes: "Notizen",
    notesPlaceholder: "Notiz oder Kommentar für den Kunden hinzufügen...",
    minimumCharacters: "{{count}}/20 Zeichen mindestens",
    selectedCallbackDate: "Ausgewählter Rückruf: {{date}}",
    saveAndComplete: "Speichern und abschließen",
    contactHistory: "Kontaktverlauf",
    createdBy: "Erstellt von:",
    noContactHistory:
      "Für diesen Lead ist kein Contact-Cloud-Verlauf verfügbar.",
    activities: "Aktivitäten",
    script: "Skript"
  },
  agentRouteSwitch: {
    title: "Agenten-Warteschlange wechseln?",
    message:
      "Möchten Sie zu {{target}} wechseln? Ihre aktuelle Zuweisung wird freigegeben und Sie werden der nächsten Warteschlange zugewiesen.",
    continue: "Weiter",
    stay: "Hier bleiben",
    releaseError: "Die aktuelle Zuweisung konnte nicht freigegeben werden.",
    activeCallError:
      "Bitte beenden Sie den aktuellen Anruf, bevor Sie ein anderes Panel öffnen."
  },
  removeFromLeadserviceBtn: "Aus Lead-Service entfernen",
  removeFromLeadserviceConfirmationMsg:
    "Bist du sicher, dass du diesen Lead aus dem Lead-Service entfernen möchtest?"
};
